export const en = {
  myTransactions: 'My Transactions',
  customerNumber: 'Customer number',
  noTransactions: 'There are no transactions',
  insurances: 'Insurances',
  reportDamage: 'Report damage',
  tryAsClient: 'Try as a client',
  adminMode: 'Admin mode',
  personalData: 'Personal data',
  flowManagement: 'Flow Management',
  auditClaims: 'Audit Claims',
  myDamages: 'My claims',
  date_on_contract_is_to_be_reactivated:
    'Select the date on which the contract is to be reactivated',
  AdminChanges: 'Admin Changes',
  protectedInsuranceArea: 'Protected insurance area',
  loginInfo: `To view your insurance documents, please log in to our protected area. Here you will find, among other things, information on the subject of reporting a claim. After entering your e-mail address, you will receive an access link. Also you can send your Policy ID and get confirmation code on youre-mail address.`,
  yourNewEmail: 'Your new e-mail address',
  yourPassword: 'Your password',
  requestLoginLink: 'Request login link',
  pandaPetIns: 'Panda pet insurance',
  pandaInsurTech: 'Panda InsurTech GmbH',
  riskTaker: 'Risk carrier',
  riskTakerAddress: `InterRisk Versicherungs-AG
  <br />
  Vienna Insurance Group
  <br />
  Carl-Bosch-Str. 5
  <br />
  65203 Wiesbaden
  <br />
  Germany`,
  commercial: 'Commercial Register:',
  commercialRegister: `<span>HRB 8043</span>
  <br />
  Registergericht Wiesbaden
  <br />
  VersSt-Nr.: 807/V90807012122`,
  member: 'Members of the Board:',
  memberBoard: `<span>
              Dr. Florian Sallmann (Chairman),
              <br />
              Beate Krost,
              <br />
              Christoph Wolf
            </span>
            <br />
            <strong>
            Vorsitzender des Aufsichtsrates:
            </strong>
            <br />
            Mag. Liane Hirner (Chairwoman)`,
  imprint: 'Imprint',
  dataProtection: 'Data protection',
  contact: 'Contact',
  faq: 'FAQ',
  flows: 'Flows',
  noFlowsCreateNew: 'No flows. Create a new one!',
  diagnosis: 'Diagnosis',
  got: 'GOT',
  edit: 'edit',
  delete: 'delete',
  weWorkingClaims: 'We are working on your claims.',
  goBackSeeHistory: `You can go back to the claims' history to see the status of your claims and fill any missing information.`,
  close: 'Close',
  hallo: 'Hello',
  fifiChipMissing: `Kelly's chip number is still missing.`,
  addDetails: 'Add details',
  pandaPetHealth: 'Panda Pet Health Insurance',
  productVariant: 'Product variant: Panda full health insurance exclusive',
  active: 'active',
  commOfIns: 'Commencement of insurance',
  renewsOn: 'Insurance will be automatically renewed on',
  cancelledOn: 'Product cancelled as of',
  insNumber: 'Insurance number',
  petHealthDesc: `Your pet health insurance protects you from them
                           Costs in case of a necessary operation or
                           Curative treatment (if agreed) due to illness
                           or accident of your animal.`,
  details: 'Details',
  monthly: 'Monthly',
  paymentInfo: 'Payment information',
  transactionHis: 'Transaction history',
  reimCost: 'Reimbursement of costs in the event of a claim',
  insDog: 'Insured dog',
  chipNumber: 'Chip number',
  downloadDoc: 'Download documents',
  downloadDoc2: 'Get documents',
  showLess: 'Show less',
  moreInfoDoc: 'More information and documents',
  faqLong: 'Frequently Asked Questions',
  selectInvoice: 'Select the document',
  name: 'Name',
  type: 'Type',
  size: 'Size',
  group: 'Group',
  item_one: 'item',
  item_other: 'items',
  groupIntoOne: 'Group into one claim',
  analyzeNow: 'Analyze now!',
  preview: 'Preview',
  back: 'back',
  Back: 'Back',
  Next: 'Next',
  infoAboutDamage: 'Information about the damage',
  date: 'Date',
  time: 'Time',
  invoiceNumber: 'Invoice number',
  describeWhatHappen: 'Please describe what happened as precisely as possible',
  specificInfo: 'Specific information on the refund request',
  pet: 'Pet',
  yourDogChip: `Your dog's microchip number`,
  whatTreatmentType: 'What type of treatment did your dog receive?',
  whatTreatmentTakePlace: 'When did the treatment take place?',
  preIdentifyDiag: 'Pre-indentifed diagnosis (select one)',
  noneAbove: 'None of the above',
  info: 'Information',
  symptoms: 'Symptoms',
  cause: 'Cause(s)',
  confirmSelection: 'Confirm selection',
  otherDiag: 'Other diagnosis (select one)',
  diag: 'Diagn',
  invoiceDate: 'Date of invoice',
  desc: 'Description',
  count: 'Count',
  unitPrice: 'Unit Price',
  total: 'Total',
  totalAmount: 'Total amount',
  totalAmount2: 'Gross',
  addGot: 'Add GOT',
  gotCheckPass: 'GOT check passed.',
  gotCheckFailed: 'GOT check failed.',
  gotSelection: 'GOT Selection',
  noGotSelection: 'No GOT selected',
  updateGot: 'Update GOT',
  updateInfo: `If you update your information, the progress will not be saved and
            you will have to upload this invoice. You can also finish this step
            and update your information later.`,
  profilePage: 'Profile page',
  updateVendorInfo: 'Update vendor information',
  updateInformation: 'Update information',
  paymentInformation: `In the event of a refund, payment should be made to the following
        account:`,
  cardNumber: 'IBAN',
  accountOwner: 'Account owner',
  questionOrSuggestion: 'Do you have a question or suggestion?',
  send: 'Send',
  customerNum: 'Customer No.',
  element: 'ELEMENT',
  title: 'Title',
  firstName: 'First name',
  lastName: 'Last name',
  address: 'Address',
  street: 'Street',
  houseNumber: 'House number',
  postcode: 'ZIP code',
  city: 'City',
  birthDate: 'Birth date',
  contactDetails: 'Contact details',
  email: 'E-mail address',
  phone: 'Phone number',
  saveChanges: 'Save changes',
  weAreAnalyzing: 'We are analyzing your information',
  from: 'From',
  to: 'To',
  answer: 'Answer',
  answersCompleted: 'All answers in this flow were completed!',
  fillMissingInfo: 'Please fill the missing information',
  taxAndName: 'Tax ID and Name',
  status: 'Status',
  action: 'Action',
  policyNumber: 'Policy Number',
  customerName: 'Customer Name',
  moreDetails: 'more details',
  id: 'id',
  quantity: 'Quantity',
  amount: 'Amount',
  amount2: 'Net',
  netto: 'Net',
  noClaims: 'There are no claims',
  updateFlow: 'Update flow',
  createFlow: 'Create flow',
  goBack: 'Go back',
  editView: 'Edit view',
  zoom: 'Zoom',
  zoomView: 'Zoom view',
  yourInfo: 'Your information',
  myPets: 'My pets',
  yourInfoNotUpDate: 'Are your information not up to date?',
  yourVendorInfo: `Your vendor's information`,
  editVendorInfo: `Edit your vendor's information`,
  taxId: 'Tax ID',
  totalNet: 'Total net',
  tax: 'Tax',
  VatCheckPassed: 'VAT check passed.',
  VatCheckFailed: 'VAT check failed.',
  totalGross: 'Total gross',
  invoiceTotalCheckPassed: 'Invoice total check passed.',
  invoiceTotalCheckFailed: 'Invoice total check failed.',
  inProgress: 'in progress',
  fillInfo: 'fill the info',
  'complete the flow': 'complete the flow',
  Finish: 'Finish',
  lineItem_one: 'line item',
  lineItem_other: 'line items',
  about: 'About',
  updateLogo: 'Update logo',
  auditDuplicated: 'Audit Duplicated',
  auditPrevention: 'Audit Prevention',
  auditOCR: 'Audit OCR',
  auditClaimsBack: 'Back to audit page',
  policyID: 'Policy ID',
  policyNo: 'Policy No',
  typeToSearch: 'Type to search policies',
  petName: 'Pet name',
  veterinarian: 'Vet name',
  match: 'Match',
  totalTax: 'Tax',
  claimsPendingReview: 'Claims pending review',
  claimsReviewed: 'Claims reviewed',
  checked: 'Checked',
  identifiedSuccess: 'Identified correctly',
  identifiedWrong: 'Identified wrong',
  petTriggerTooltip:
    'Please write the word which helped you to identify the pet',
  chipTriggerTooltip:
    'Please write the word which helped you to identify the chipnummer',
  comment: 'Comment',
  isOfPending: 'claims is pending out of',
  allCompared: 'All items compared.',
  yes: 'Yes',
  no: 'No',
  rate: 'Success rate',
  empty: 'Empty',
  allDamages: 'All Damages',
  search: 'Search',
  confirm: 'Confirm',
  invoiceInfo: 'Invoice info',
  petInfo: 'Pet info',
  chipNumberTrigger: 'Chip trigger word',
  petNameTrigger: 'Pet name trigger word',
  incidentDate: 'Incident Date',
  decisionDate: 'Decision date',
  gender: 'Gender',
  breed: 'Breed',
  firstBreed: 'First breed',
  secondBreed: 'Second breed',
  damage: 'Damage',
  damageLocation: 'Damage location',
  seeInitDoc: 'See initial document',
  seeLineItems: 'See line items',
  duplTrue: 'Duplicate true',
  prevTrue: 'Prevention true',
  duplFalse: 'Duplicate false',
  prevFalse: 'Prevention false',
  confirmed: 'Confirmed!',
  ocrLoaded: 'OCR loaded.',
  update: 'Update',
  totalInfo: 'Total info',
  itemInfo: 'Itemized info',
  preventionEmpty: 'No more items.',
  Category: 'Category',
  Trigger: 'Trigger',
  actions: 'Actions',
  Options: 'Options',
  BackToFlow: 'Back to flow',
  createDropdown: 'Create dropdown',
  editDropdown: 'Edit dropdown',
  Logout: 'Logout',
  Font: 'Font',
  Settings: 'Settings',
  PrimaryColor: 'Primary color',
  SecondaryColor: 'Secondary color',
  TreatmentType: 'Treatment type',
  TreatmentDate: 'Treatment date',
  vendorTaxId: 'Vendor Tax ID',
  vendorAddress: 'Vendor address',
  save: 'Save',
  ShowUnread: 'Show unread messages',
  areYouSure: 'Are you sure?',
  itMight:
    'It might restart the claim process and hence delay the adjudication.',
  Cancel: 'Cancel',
  editDamage: 'Edit damage',
  Invoice: 'Invoice',
  invoice: 'invoice',
  payment: 'Payment',
  vendorName: 'Vendor name',
  add: 'Add',
  question: 'Question',
  done: 'Done',
  notSure: 'Not sure',
  width: 'Width',
  recTriggers: 'Recognized triggers',
  prevNotSure: 'Prevention not sure',
  prevMixedBill: 'Prevention mixed bill',
  mixedBill: 'Mixed bill',
  English: 'English',
  German: 'German',
  diagnosisTrigger: 'Diagnosis Trigger',
  allDatesSame: 'Set all dates as first',
  claim: 'Claim',
  claimNo: 'Claim no.',
  noDiag: 'No diagnose',
  askForEdit: 'Request other changes',
  vet: 'Veterinarian',
  userMode: 'User mode',
  getConfirmCode: 'Get confirmation code',
  submitCode: 'Submit code',
  confirmCode: 'Confirmation code',
  confirmEmail: 'Confirm your new e-mail',
  submitPolicy: 'Submit policy',
  submitEmail: 'Submit your e-mail',
  whichPet: 'Which animal would you like to choose?',
  allAnimals: 'All animals',
  uploadFoto: 'Upload a picture of your your four-legged friend.',
  petProduct: "'s products",
  firstSight: 'at a glance',
  backTo: 'back to the ',
  Selection: 'selection',
  changePetData: 'Change pet data',
  What_would_you_like_to_do: 'What would you like to do?',
  Change_deductible: 'Change deductible',
  changeData: `Change data`,
  krankenExklusiv: 'Exclusive health insurance',
  insPremium: 'Insurance premium',
  paymentMethod: 'Payment method',
  changePayment: 'Change payment method',
  whatCovered: `What is covered by your <span>tariff</span>?`,
  compensations: 'Reimbursement of costs',
  annMaxOPs: 'Annual maximum OPs',
  annMaxTreat: 'Annual maximum treatments',
  waitingStart: 'Waiting period from start of insurance',
  pandaBudget: 'PANDA protection budget',
  changeContract: 'Change contract',
  whatToDo: 'What would you like to do?',
  accident: 'Accident',
  prevention: 'Prevention',
  treatment: 'Treatment',
  preventionTreatment: 'Prevention & Treatment',
  PreventionTreatment: 'Prevention & Treatment',
  typeSelect: 'Please select type of claim',
  noStatus: 'No status',
  firstTrigger: 'First trigger',
  secondTrigger: 'Second trigger',
  preventionStatus: 'Prevention status',
  noTrigger: 'No trigger',
  noCategory: 'No category',
  sendEmail: 'Send email',
  callBack: 'Request a callback',
  cdFirst: 'Change',
  cdSecond: 'data',
  sendBill: 'submit new invoice',
  resendDocs: 'Submit an additional document',
  costCalc: 'Cost estimate',
  billDir: 'Direct billing with vet/veterinary clinic',
  uploadPhoto: 'upload a picture here',
  sendUsEmail: 'Send us an e-mail to',
  replyAsap: 'We will answer immediately!',
  yourName: 'Your name',
  message: 'Message',
  arrangeCall: 'Arrange a call appointment',
  willDiscuss: 'We will call you and discuss all your questions with you!',
  sendChoose: `Please just leave us your phone <span>number</span> and choose your <span>appointment</span>.`,
  yourPhone: 'Your phone number',
  selectDate: 'Select your preferred date',
  whatChange: 'What would you like to change?',
  changeEmail: 'Change email address',
  changeBD: 'Change date of birth',
  changeElse: 'Change something else',
  enterBD: 'Enter your date of birth here:',
  enterEmail: 'Enter your new e-mail address here:',
  Rechnungen: 'Claims',
  rechnungen: 'claims',
  AdditionalProperties: 'Additional information on the claim',
  dateRangePlaceHolder: 'Start - End',
  disabled: 'Disabled',
  halfWidth: 'Half width',
  fullWidth: 'Full width',
  'Open question': 'Open question',
  'New claim': 'New Document',
  'New Document': 'New Document',
  Type: 'Type',
  'End flow': 'End flow',
  'Multiple Choice Question': 'Multiple Choice Question',
  Upload: 'Upload',
  Date: 'Date',
  'Invoice Table': 'Invoice Table',
  'Date range': 'Date range',
  'Existing claim': 'Additional questions',
  'Additional questions': 'Additional questions',
  'Default value': 'Default value',
  values: 'Values',
  Accident: 'Accident',
  Prevention: 'Prevention',
  'to be paid': 'to be paid',
  'to reject': 'to reject',
  'to review': 'to review',
  selectDefaultValue: 'Select default value',
  'Customer address': 'Customer address',
  'Customer address recipient': 'Customer address recipient',
  'Customer id': 'Customer id',
  'Customer name': 'Customer name',
  'Invoice date': 'Invoice date',
  'Invoice id': 'Invoice id',
  'Invoice total': 'Invoice total',
  'Sub total': 'Sub total',
  'Total tax': 'Total tax',
  'Vendor address': 'Vendor address',
  'Vendor address recipient': 'Vendor address recipient',
  'Vendor name': 'Vendor name',
  'Vendor tax id': 'Vendor tax id',
  yourAttachments: 'Your attachments',
  enter: 'Enter your request HERE.',
  createNewApproach: 'Create a new approach',
  sendRequest: 'Send request',
  sendChange: 'Send change request',
  otherRequest: 'Other Request',
  enterDate: 'Enter date',
  retriever: 'Nova Scotia Duck Tolling Retriever',
  thankMsg: 'We have received your request. You will receive feedback shortly.',
  thankMsgFooter: 'The PANDA team wishes you a nice day!',
  seeDetails: 'Product details',
  callbackConfirmed: 'Your request has been accepted. Wait for our call.',
  emailConfirmed: 'Your message has been sent. Please wait for our reply.',
  notInvoice: 'Not invoice',
  variants: 'Variants',
  errorMsg: 'Oops, something went wrong. Please try again.',
  Amount: 'Amount',
  next: 'next',
  loginWelcome: 'Welcome to the PANDA Customer Portal',
  register: 'Log in here with your e-mail address.',
  codeSent:
    'We have now sent you a login code to your email address. Please enter the code we sent to your email address here.',
  errorEmail: `ATTENTION!<br/>Please enter the email address you used when you purchased the insurance.<br/><br/>You can't remember your email address?`,
  errorAdminEmail: `ATTENTION!<br/>Please enter the email address you used when you purchased the insurance.<br/><br/>`,
  errorPolicyId: `ATTENTION!<br/>Please enter correct policy number.<br/><br/>`,
  support: 'Then contact our SUPPORT',
  Implementation_date: "Implementation date",
  supportContact: 'Support contact',
  toSend: 'send',
  tt_cover_70: `You have insured a tariff with 70% excess, so we can only reimburse 70% of your costs.`,
  tt_cover_80: `You have insured a tariff with 80% excess, so we can only reimburse 80% of your costs.`,
  tt_cover_100: `You have insured a tariff with 100% excess, so we can only reimburse 100% of your costs.`,
  tooltip1_OP: `Castration/sterilisation is medically necessary in the presence of gynaecological or oncological diseases (e.g. inflammation or tumorous changes in the reproductive organs or other hormone-dependent tumours).`,
  'tooltip1_KR_02-2026_XXL': `Castration/sterilisation is medically necessary in the presence of gynaecological or oncological diseases (e.g. inflammation or tumorous changes in the reproductive organs or other hormone-dependent tumours).\n\nReimbursement within the PANDA protection budget up to 70€ possible.`,
  'tooltip1_KR_02-2026_XXXL': `Castration/sterilisation is medically necessary in the presence of gynaecological or oncological diseases (e.g. inflammation or tumorous changes in the reproductive organs or other hormone-dependent tumours).\n\nReimbursement within the PANDA protection budget up to 100€ possible.`,
  'tooltip2_02-2026': `Reimbursement is possible within the framework of the Panda Protection Budget.`,
  tooltip1_KR: `Castration/sterilisation is medically necessary in the presence of gynaecological or oncological diseases (e.g. inflammation or tumorous changes in the reproductive organs or other hormone-dependent tumours).\n\nReimbursement within the PANDA protection budget up to € 70 possible.`,
  tooltip2: `You have insured a tariff with {{}}% cover, so we can only reimburse {{}}% of your costs.`,
  tooltip3_XL: 'Health flat rate of 70€, applicable to one of the following services: preventive examination, castration/sterilisation or dental prophylaxis, vaccination, flea and tick prevention, physiotherapy and alternative healing methods (e.g. laser therapy, homeopathy) as well as treatments due to pregnancy / delivery.',
  tooltip3_XXL: 'Health flat rate of 70€, applicable to one of the following services: preventive examination, castration/sterilisation or dental prophylaxis, dental fillings, dentures and dental corrections, vaccination, flea and tick prevention as well as treatments due to pregnancy / delivery.',
  tooltip3_XXXL: 'Health flat rate of 100€, applicable to one of the following services: preventive examination, castration/sterilisation or dental prophylaxis, dental fillings, dentures and dental corrections, vaccination, flea and tick prevention as well as treatments due to pregnancy / delivery.',
  tooltip3: `a) Preventive examinations and health checks including blood tests;\nb) Dental prophylaxis (teeth cleaning/tartar removal) Dental prophylaxis (teeth cleaning/tartar removal);\nc) Worming;\nd) Vaccinations;\ne) Flea and tick prevention;\nf) Castration or sterilisation without medical indication;\ng) Claw trimming;\nh) Preparation of health certificates and expert opinions;\ni) Manual anal bag emptying;\nj)	Animal care products purchased through dealers selected by PANDA;\nk) Treatments due to pregnancy and delivery/birth (does not apply to breeding animals);\nl) Cancer screening and/or disease check-up for animals from abroad. \nm) Physiotherapy and behavioral therapy, provided the respective healing methods are carried out by recognized/licensed physiotherapists or behavioral therapists, as well as alternative healing methods (including acupuncture, acupressure, homeopathy, laser therapy, magnetic field therapy, neural therapy, bioresonance therapy, phytotherapy, chiropractic and osteopathy), provided the treatments are carried out by the veterinarian himself. Excluded in any case are behavioral therapies for cats and all treatments by bloodletting. Compensation is limited to one of the listed benefits up to a maximum of € 70 per insurance year. The benefit will be offset against an existing maximum annual benefit. If you have not received any reimbursement for the above-mentioned measures in one year, i.e. you have not taken advantage of any measures from the PANDA protection budget, the limit of the PANDA protection budget is doubled from € 70 to € 140 in the following year. In the following year, the originally specified maximum annual limit applies again until the conditions stated in the first sentence are met again.`,
  tooltip4: 'Please note the special waiting times in the table below.',
  tooltip5: `Insurance ends on`,
  dataChangesConfirmed:
    'Your request has been sent. Please wait for our reply.',
  addDocument: 'Add another document',
  pandaLoading: 'Thank you! We are now processing this information.',
  month: 'month',
  perInsYear: 'per insurance year',
  tariffInfo: 'Information about your tariff',
  specialWaitingPreiod_3: 'Special waiting period of 3 months',
  specialWaitingPreiod_12: 'Special waiting period of 12 months',
  specialWaitingPreiod_18: 'Special waiting period of 18 months',
  notInsured: 'This is not insured, among other things',
  'Erkrankungen, die vor Versicherungsbe - ginn oder in der Wartezeit bekannt/diagnostiziert waren':
    'Illnesses that were known/diagnosed before the start of the insurance or during the waiting period',
  'Kieferanomalien (z.B. Persistierende Milchzähne)':
    'Jaw anomalies (e.g. persistent milk teeth)',
  'Persistierende Milchzähne': 'Persistent milk teeth',
  'Leistungen aus der Trächtigkeit (z.B. Not - kaiserschnitt)':
    'Benefits from pregnancy (e.g. emergency caesarean section)',
  'Nicht medizinisch notwendige Kastration oder Sterilisation':
    'Castration or sterilisation that is not medically necessary',
  userLogin: 'User Login',
  dateRangeError: 'Please choose correct dates for date range',
  noInfo: 'No information',
  claimSuccess: 'Your claim has been registered successfully',
  'Error, reloading...': 'Error, reloading...',
  'Something going wrong...': 'Something going wrong...',
  cancelContract: 'Cancel contract',
  whichPetCancel: 'For which animal would you like to cancel the contract?',
  whicContractCancel: 'Which contract would you like to cancel?',
  selectOption: 'Please select an option:',
  '30PeriodNotice': "The selected date is outside the 30-day period.",
  selectOption2: 'Please select an option',
  'Ordinary cancelation': 'Ordinary cancelation',
  'Cancellation for other reasons': 'Cancellation for other reasons',
  Revocation: 'Revocation',
  hintModal:
    'If the contract is revoked/cancelled, you can no longer activate the contract.',
  hint: 'Note',
  ContractEnds1:
    'The contract ends in compliance with the contractually stipulated cancellation period at the end of the contract, i.e. on ',
  afterReason2: 'The contract ends on XX.XX.XXXX.',
  afterReason3: 'Please specify the circumstances:',
  selectHere: 'Select here',
  'Animal given away': 'Animal given away',
  'Animal sold': 'Animal sold',
  'Animal handed over to animal welfare':
    'Animal handed over to animal welfare',
  'Animal deceased': 'Animal deceased',
  'Policyholder deceased': 'Policyholder deceased',
  'Moving abroad': 'Moving abroad',
  Miscellaneous: 'Miscellaneous',
  areYouSureToCancel_start: 'Are you sure you want to cancel',
  areYouSureToCancel_end:
    ' contract?<br/>You can no longer reactivate it afterwards.',
  emailSent_main:
    'We have received your cancellation request. You will receive a confirmation by email shortly.',
  emailSent_revoke:
    'We have received your cancellation request. You will receive a confirmation by email shortly.',
  toStartPage: 'To start page',
  pleaseAttach:
    'Please upload a corresponding proof document (e.g. photo of the EU pet passport).',
  pleaseAttachCustomer:
    'Please upload a corresponding proof document (e.g. photo of your identity card).',
  pleaseUpload: 'Please upload a verification document here:',
  uploadDocument: 'Upload document',
  '1. Vers. Jahr': '1st ins. year:',
  'ab 2. Vers. Jahr:': 'from 2nd ins. year:',
  '1 Monat': '1 month',
  'bei Unfall:': 'In case of accident:',
  'bei Verkehrsunfall:': 'In case of traffic accident:',
  keine: 'none',
  docUploadPlaceholder: 'Place documents to upload here',
  invoiceUploadSubmitText: 'Upload invoice',
  uploadedDocuments: 'Uploaded documents',
  submitInvoice: 'Submit invoice',
  submitDocument: 'Submit document',
  whichPetContinue: 'For which animal would you like to continue?',
  myProducts: 'My products',
  myInvoices: 'My claims',
  quantity2: 'Quantity',
  pleaseCheckData:
    'Feel free to review the invoice details and adjust them if needed. If individual items have not been recognised correctly, please don’t worry – our team also checks all information manually. Simply click “Next”.',
  pleaseSelectClaim_G:
    'Please select the claim for which the document is to be submitted.',
  pleaseSelectClaim_CE:
    'Please select the claim for which the cost estimation is to be submitted.',
  invoiceDetails: 'Invoice details',
  attention:
    '*Attention, there are legal consequences if data is knowingly provided incorrectly.',
  correctData: 'Correct data / add new line',
  resetChanges: 'Reset changes',
  pleaseRemove: 'Please remove the items that you do NOT WANT us to refund',
  areNotRefund: 'Are there any invoice items that we should NOT refund?',
  invoicesForVerification: 'These invoice items are forwarded for verification',
  justClick: 'Please simply click in the fields to correct the data. Click Add Line to start adding values.',
  missingDiag: 'Diagnosis missing',
  chipDoesNotMatch: 'Chip number does not match',
  missingChip: 'Chip number missing',
  cantFindDiag_inv:
    'Unfortunately, we could not find a diagnosis on your invoice, but we need this for processing. Is the diagnosis included on your invoice?',
  cantFindDiag_doc:
    'Unfortunately, we could not find a diagnosis on your document, but we need this for processing. Is the diagnosis included on your document?',
  cantFindChip_inv:
    'Unfortunately, we could not find a chip number on your invoice, but we need it to process your invoice. Is the chip number on your invoice?',
  cantFindChip_doc:
    'Unfortunately, we could not find a chip number on your document, but we need it to process your document. Is the chip number on your document?',
  chipDoesNotMatch1_inv:
    "Unfortunately, the chip number on the invoice does not match the chip number on your pet's contract.",
  chipDoesNotMatch1_doc:
    "Unfortunately, the chip number on the document does not match the chip number on your pet's contract.",
  chipDoesNotMatch2_inv:
    'Is the chip number stated on the invoice the correct chip number for your pet?',
  chipDoesNotMatch2_doc:
    'Is the chip number stated on the document the correct chip number for your pet?',
  hasDuplicate1_inv:
    'This invoice has already been submitted and is being processed under service case number ',
  hasDuplicate1_doc:
    'This document has already been submitted and is being processed under service case number ',
  hasDuplicate2: 'Has data – such as diagnosis or chip number – been added?',
  sureReuploadClaim_inv: 'Are you sure you still want to resubmit the invoice?',
  sureReuploadClaim_doc:
    'Are you sure you still want to resubmit the document?',
  thankModal_inv:
    'Thank you very much. If you have any questions about the processing status of an invoice that has already been submitted, you can view this under “My claims“.',
  thankModal_doc:
    'Thank you very much. If you have any questions about the processing status of a document that has already been submitted, you can view this under “My claims“.',
  customerPortal: 'Customer portal',
  thankForUpload_G_inv:
    'Thank you for uploading your invoice!',
  thankForUpload_G_doc:
    'Thank you for uploading your document!',
  thankForUpload_G_few_inv:
    'Thank you for uploading your invoices!',
  thankForUpload_G_few_doc:
    'Thank you for uploading your documents!',
  thankForUpload_CE:
    'Thank you for uploading your cost estimation!',
  thankForUpload_CE_few:
    'Thank you for uploading your cost estimations!',
  thankForUpload_LC:
    'Thank you for uploading your document!',
  thankForUpload_LC_few:
    'Thank you for uploading your documents!',
  nowProcessed_G:
    'This is now being processed by us and we will get back to you shortly.',
  nowProcessed_GV: 'This is now being processed by us.',
  nowProcessed_EC: 'We will forward it for processing.',
  nowProcessed_LC:
    'These are now being processed by us and we will get back to you shortly.',
  nowProcessed_CE:
    'This is now being processed by us and we will get back to you shortly.',
  loaderText: 'Please wait a moment',
  loaderSubText: 'Your documents are being uploaded.',
  loaderSubText_CE: 'Your cost estimation are being uploaded.',
  loaderSubText2:
    'We are processing your document, this can take a few moments...',
  seeAdvice: 'See advice',
  adjudication: 'Adjudication recommendations',
  CostEstimation: 'Cost estimation',
  costEstimation: 'cost estimation',
  reportLiab: 'Report liability claim',
  doesBelongExistingClaim1: 'Does the ',
  doesBelongExistingClaim1_CE: 'Does the ',
  doesBelongExistingClaim2: ' belong to an existing claim?',
  confirmChangeData_1: 'Thank you very much,',
  confirmChangeData_2:
    'We have received your change request for implementation. This is now being processed by us. You will shortly receive a confirmation to the email address stored in your contract.',
  confirmChangeData_3: 'The PANDA team wishes you a great day!',
  'Welches Dokument möchten Sie nachreichen?':
    'Which document do you want to submit?',
  'Your benefit cases': 'Your benefit cases',
  deleteLine: 'Delete line',
  addLine: 'Add line',
  paymentTile: 'Desired account for transfer',
  paymentDescription: 'Which account should we transfer the payment to?',
  Payment: 'Payment',
  chipWrong: 'Incorrect chip number. It must contain 15 digits.',
  emailWrong: 'Incorrect email.',
  confirmEmailWrong:
    'Please double-check your email and confirmation email. They do not match.',
  Document: 'Document',
  document: 'document',
  claimType: 'Claim type',
  'Cost estimation_': 'Cost estimation',
  'Liability claim_': 'Liability claim',
  'General to Vets_': 'Direct billing with vet/veterinary clinic',
  General_: 'Invoice',
  docPreview: 'Document preview',
  'Existing Claim_': 'Existing Claim',
  duplicateTo: 'Duplicate to: ',
  thankYouPageIngo:
    'It may turn out during the invoice verification that we cannot pay all the amounts invoiced by the vet in full because they are not covered or not covered in full under your contract (e.g. excess or annual maximum benefit). Once the invoice has been checked, you will receive a statement from us showing the amounts charged directly. If we were unable to pay the invoice in full, we will inform you of the amount to be reimbursed by you to the vet.',
  achtung: 'Please note!',
  achtungChip_CE:
    '*Attention, your cost estimation must include a chip number!',
  achtungChip_GtV:
    'Please make sure that the invoice is fully legible and not covered (e.g. receipt, finger, shadow, etc.)',
  achtungChip: '*Attention, your invoice must include a chip number!',
  uploadInvoiceLimit: 'Uploading is limited to one document. If your invoice consists of several pages, please upload it as a PDF file. If your invoice consists of only one page, you can also upload it as a photo. Additional invoices for the same treatment case can be uploaded later as supplementary documents.',
  LoginAsUser: 'Login as user',
  Submit: 'Submit',
  'Logout as user': 'Logout as user',
  createTicket: 'Create ticket',
  ticket: 'Ticket',
  bug: 'Bug',
  error: 'Error',
  enhancements: 'Enhancements',
  petPage: 'Pet`s page',
  page: 'Page',
  ticketConfirmed: 'Ticket created',
  noteScreenshot:
    'Please note that the screesnhot of the page would be taken automatically.',
  Unbekannt: 'Unknown',
  needChip:
    'We need a chip number to check your claim. Please have the vet complete the chip number and then upload the document again.',
  needChipYes:
    "Please request a change to your pet's chip number in the customer portal.",
  needChipNo_inv:
    "Please contact your veterinary practice and ask them to issue a corrected invoice with your pet's correct chip number. Please then resubmit the corrected invoice.",
  needChipNo_doc:
    "Please contact your veterinary practice and ask them to issue a corrected document with your pet's correct chip number. Please then resubmit the corrected document.",
  needDiag_inv:
    'We need a diagnosis to check your claim. Please have the diagnosis completed by your vet and then upload the invoice again.',
  needDiag_doc:
    'We need a diagnosis to check your claim. Please have the diagnosis completed by your vet and then upload the document again.',
  needDiag_EC:
    'You have selected Submit diagnosis and confirmed in the next step that there is no diagnosis on the document. Please have the vet complete the diagnosis and then upload the document again.',
  noClaimsToAdd: "You don't have any claims to add to yet.",
  claimChecks: 'Claim checks',
  wasChipOnInvoice: 'Was chipnmuber on invoice:',
  wasDiagOnInvoice: 'Was diagnosis on invoice:',
  isItPolicyDR: 'Is it policy date range:',
  isItDupl: 'Is it a duplicate:',
  containPrevent: 'Does it contain prevention:',
  somethingWentWrong: 'Something went wrong! Please try again later.',
  errorReloading: 'Error, reloading...',
  successfullyUpdated: 'Successfully updated!',
  maxRequstLimitReached:
    "Your last claim didn't completed yet, please try again later.",
  loadingFlowText: 'Please wait a moment...',
  sendChangeRequest: 'Save changes',
  submissionDate: 'Submission date',
  ContractInformation: 'Contract information',
  tariff: 'Tariff',
  'Policy is not terminated': 'Policy is not terminated',
  submittedDocs: 'Documents submitted',
  submittedOn: 'submitted on ',
  coverage: 'Reimbursement of costs',
  detailedView: 'Detailed view',
  claimLC: 'Liability insurance claim',
  addDescr: 'Add description',
  datePlaceholder: 'DD.MM.YYYY',
  "YY": "YY",
  "DD": "DD",
  "MM": "MM",
  customerChanged: '*Customer changes made',
  policyReactivate: 'Reactivate policy',
  invoiceLink: 'Invoice link',
  yourDocuments: 'Your documents',
  Male: 'Male',
  Female: 'Female',
  diverse: 'Diverse',
  year: 'year',
  halfYear: 'half-year',
  quarter: 'quarter',
  readClaim: 'Read claim',
  analyzeClaim: 'Analyze claim',
  nothingToChange: "Sorry, you can't change your pet's details yourself.",
  no_waiting_time: 'no waiting time',
  unlim: 'unlimited',
  day_30: '30 days',
  day_20: '20 days',
  day_14: '14 days',
  day_5: '5 days',
  month_1: '1 month',
  'Onkologische Krankheiten (bösartige Tumore)':
    'Oncological diseases (malignant tumours)',
  'Onkologische Krankheiten (gutartige Tumore)':
    'Oncological diseases (benign tumours)',
  'Onkologische Krankheiten (gutartige und bösartige Tumore)':
    'Oncological diseases (benign and malignant tumours)',
  'Erkrankungen, die vor Versicherungsbeginn oder in der Wartezeit bekannt/diagnostiziert waren':
    'Illnesses that were known/diagnosed before the start of the insurance or during the waiting period',
  Kreuzbandrisse: 'Cruciate ligament ruptures',
  Pankreatitis: 'Pancreatitis',
  Niereninsuffizienz: 'Renal insufficiency',
  'Nickhautdrüsenvorfall/Cherry Eye': 'Nictitating gland prolapse/cherry eye',
  'Epiliepsie/Krampfanfälle': 'Epilepsy/seizures',
  'Hüftgelenksdysplasie (HD)': 'Hip joint dysplasia (HD)',
  'Ellenbogendysplasie (ED)': 'Elbow dysplasia (ED)',
  'Hüftgelenksdysplasie (HD), Ellenbogendysplasie (ED)': `Hip joint dysplasia (HD),\nElbow dysplasia (ED)`,
  'Osteochondrosis dissecans (OCD)': 'Osteochondrosis dissecans (OCD)',
  'Frakturierter Processus Coronoideus (FPC)':
    'Fractured coronoid process (FPC)',
  'Isolierter Processus Anconaeus (IPA)': 'Isolated processus anconaeus (IPA)',
  'Radius Curvus (Short-Ulna-Syndrom)': 'Radius curvus (short ulna syndrome)',
  Herzerkrankungen: 'Heart disease',
  Allergien: 'Allergies',
  'Erworbene Herzerkrankungen und Allergien':
    'Acquired heart disease and allergies',
  'Schilddrüsenerkrankungen bei Hunden': 'Thyroid diseases in dogs',
  'Goldakupunktur bzw. Prothesen/Implantate':
    'Gold acupuncture or prostheses/implants',
  Kryptorchismus: 'Cryptorchidism',
  Entropium: 'Entropion',
  Ektropium: 'Ectropion',
  Prothesen: 'Prostheses',
  'Cherry-Eye': 'Cherry-Eye',
  'Cherry-Eye/Nickhautdrüsenvorfall': 'Cherry eye/nictitating gland prolapse',
  Nabelbruch: 'Umbilical hernia',
  Kreuzbandriss: 'Cruciate ligament rupture',
  Arthrosen: 'Arthroses',
  'Brachyzephales Syndrom': 'Brachycephalic syndrome',
  Patellaluxation: 'Patellar luxation',
  Dackellähmung: 'Dachshund paralysis',
  Epilepsie: 'Epilepsy',
  'Epilepsie / Krampfanfälle': 'Epilepsy / seizures',
  'Polyzistische Nierenerkrankung (PKD)': 'Polycystic kidney disease (PKD)',
  'Spinale Muskelatrophie (SMA)': 'Spinal muscular atrophy (SMA)',
  'Mucopolysaccharidose (MPS VI)': 'Mucopolysaccharidosis (MPS VI)',
  Anaplasmose: 'Anaplasmosis',
  'Wobbler-Syndrom': 'Wobbler syndrome',
  'Niereninsuffizienz/Nierensteine': 'Renal insufficiency/kidney stones',
  'Nur für Katzen: Schilddrüsenerkrankungen': 'For cats only: thyroid diseases',
  'Herzerkrankungen, Allergien': 'Heart disease, allergies',
  'Erworbene Herzerkrankungen und Allergien, Unverträglichkeiten und Atopie': 'Acquired heart diseases and allergies, intolerances and atopy',
  'Gilt nur für Katzen:': 'Applies only to cats:',
  'FORL/CORL': 'FORL/CORL',
  'Canine/Feline Vector Borne Diseases (CVBD/FVBD)':
    'Canine/Feline Vector Borne Diseases (CVBD/FVBD)',
  Bandscheibenvorfall: 'Slipped disc',
  Bandscheibenvorfälle: 'Herniated discs',
  'keine besondere Wartezeit': 'No special waiting time',
  '70€ je Vers. Jahr': '70€ per insurance year',
  'OP Basic': 'OP Basic',
  'OP Comfort': 'OP Comfort',
  'OP Full': 'OP Full',
  'Health Basic': 'Health Basic',
  'Health Comfort': 'Health Comfort',
  'Health Full': 'Health Full',
  readClaimFail_start: 'Invoice could not be read please send it to ',
  readClaimFail_end: ' and refresh the page.',
  'sofort bei Unfällen': '(unlimited in case of accidents)',
  paymentPage: 'Payment page',
  exportExcel: 'Export EXCEL',
  processXML: 'Process XML',
  generatePayments: "Generate payments",
  createXML: 'Create XML file',
  customer: 'Customer',
  linkToInsly: 'Link to Insly',
  noPoliciesFound: 'No policies found',
  noInvoicesFound: 'No invoices found',
  numberOfClaims: 'Number of claims',
  processPayment: 'Process payment',
  createdXMLok: 'XML file created',
  paymentsCreate: 'Payments created',
  paymentPeriod: 'Payment period',
  paymentAmount: 'Payment amount',
  paymentDetails: 'Payment details',
  paymentStatus: 'Payment status',
  paymentDate: 'Payment date',
  selectPaymentDate: 'Select date',
  selectPaymentDateText: 'Please select a payment date for this invoice:',
  pleaseSelectPaymentDate: 'Please select a payment date for this invoice before selecting it',
  'bei Unfällen unbegrenzt': '(unlimited in case of accidents)',
  '(bei Unfällen 15.000€)': '(15.000€ in case of accidents)',
  '(bei Unfällen 2.000€)': '(2.000€ in case of accidents)',
  '(bei Unfällen 1.000€)': '(1.000€ in case of accidents)',
  unsupportedFileExtension: ' is not a supported file extension.',
  unsupportedFileExtensionMessage: 'This is not a supported file extension.',
  unsupportedFileSize: ' file size is too big',
  Refunds: 'Refunds',
  subInvTotal: 'Total amount / Invoice amount',
  subInvTotalMob: 'Total amount /\nInvoice amount',
  Payments: 'Payments',
  savePaymentMethod: 'Save payment method',
  paymentMethodSuccessfullyUpdated: 'Payment method successfully updated',
  open: 'open',
  'in progress': 'in progress',
  'closed - payment released': 'closed - payment released',
  'closed - rejection': 'closed - rejection',
  AdminChangesHeader: 'Hello, what change would you like to make?',
  'closed - no customer respond': 'closed - no customer respond',
  'closed - payment issued': 'closed - payment issued',
  reopened: 'reopened',
  'Recovery created': 'Recovery created',
  'Recovery settled': 'Recovery settled',
  canceled: 'canceled',
  attentionNoChip: 'Ooops! Chip number missing',
  chipShould15: 'The chip number must contain 15 digits',
  pleaseEnterChip: 'Please enter your chip number.',
  noteReporOnlytWithChip:
    'Please note that you can only report a claim once you have entered the chip number of your four-legged friend.',
  requestSent: 'Request has been sent',
  enterChipBefore:
    "Before you can report a claim, you must provide your pet's chip number.",
  chipHere: 'Enter the chip number here',
  Kundenservice: 'Customer portal',
  Leistungsfallabteilung: 'Claims department',
  pleaseFillInputs: 'Please fill in all mandatory fields.',
  hasOverdue: 'Has overdue',
  event: 'Event',
  iban: 'IBAN',
  female: 'Female',
  male: 'Male',
  petNameChange: 'Pet name',
  petBreedChange: 'Pet breed',
  petBDChange: 'Pet birthday',
  petChipChange: 'Pet chipnumber',
  petGenderChange: 'Pet gender',
  dogHeightChange: 'Dog height',
  catHabitatChange: 'Cat habitat',
  whichPetDataToChange: 'Which animal data would you like to change?',
  pleaseSelectHere: 'Please select here',
  pleaseEnterPetName: 'Please enter the name of your pet here.',
  pleaseSelectPetType: 'Which animal is it?',
  pleaseSelectBreedType: 'Please select breed type of your pet here.',
  pleaseSelectPetGender: 'Please select gender of your pet here.',
  pleaseEnterPetChip: 'Please enter chipnumber of your pet here.',
  pleaseEnterPetBD: 'Please enter birthday of your pet here.',
  pleaseSelectDogHeight: 'Please select height of your dog here.',
  pleaseSelectCatHabitat: 'Please select habitat of your cat here.',
  Indoor: 'Indoor',
  Outdoor: 'Outgoing',
  changeBreedMessage:
    'Would you like to finalise the process now? Please note that a change of breed may affect the price of your insurance.',
  changeBDMessage:
    'Would you like to finalise the process now? Please note that a change of date of birth may affect the price of your insurance.',
  changeHeightMessage:
    'Would you like to finalise the process now? Please note that a change in size may affect the price of your insurance.',
  changeHabitatMessage:
    'Would you like to finalise the process now? Please note that a change in your place of residence may affect the price of your insurance.',
  thankYouYesMessage: `Thank you very much,<br/><br/>We have received your change request for implementation. This is now being processed by us. You will shortly receive a confirmation to the e-mail address stored in your contract.<br/><br/>We wish you and your four-legged friend all the best!`,
  thankYouNoMessage: `We can see that you do not wish to make the change. The contract will continue as before.<br/><br/>If you have any questions, please contact our customer service team at any time!`,
  'Pet name': 'Pet name',
  'Pet breed': 'Pet breed',
  'Pet birthday': 'Pet birthday',
  'Pet chipnumber': 'Pet chipnumber',
  "The contract is terminated as of the following date": "The contract is terminated as of the following date",
  'Pet gender': 'Pet gender',
  'Dog height': 'Dog height',
  'Cat habitat': 'Cat habitat',
  pureBreed: 'Pure breed',
  hybridBeed: 'Mixed breed',
  unknownBeed: 'Unknown breed',
  dog: 'Dog',
  cat: 'Cat',
  attach: 'Add document',
  whatToChange: 'What would you like to do?',
  changeDeductible: 'Change deductible',
  changeTariff: 'Request a tariff change',
  change_tariff: 'Change tariff',
  otherEnquiry: 'Other enquiry',
  changeDeductibleTo: 'Change deductible to',
  yourNewPremiumIs: 'Your new premium is',
  whenShouldChange: 'When should the change take effect?',
  changeEffectiveFrom: 'Your change is active from',
  pleaseConfirmRequest: 'Please confirm your change request',
  thankYouMessage_changeDeductible: `Thank you,</br></br>we will forward your change request.</br>We will contact you when the change has been implemented.</br></br>The PANDA team wishes you a have a nice day!`,
  thankYouMessage_otherEnquiry: `Thank you,</br></br>we have received your enquiry.</br>We will get back to you as soon as possible. </br></br>The PANDA team wishes you a have a nice day!`,
  placeholder_1: 'Enter your enquiry HERE.',
  pleaseAnswerTruthfully: 'Please answer the following questions truthfully',
  option_noClaims:
    'No benefit (damage) has been paid so far and the animal is healthy',
  option_noClaimsSixMonths:
    'You have already received veterinary treatment (other than prevention), this was more than 6 months ago and the animal is now healthy',
  option_wasClaimed:
    'A service other than prevention has already been provided, which was not more than 6 months ago or the animal is not healthy',
  option_noClaimsENG:
    'No benefit (damage) has been paid so far and the animal is healthy',
  option_noClaimsSixMonthsENG:
    'Already received veterinary treatment (other than prevention), this was more than 6 months ago and the animal is now healthy',
  option_wasClaimedENG:
    'A service other than prevention has already been provided, which was not more than 6 months ago or the animal is not healthy',
  pleaseSelectTariff: 'Please select a tariff',
  blockedTariff_title: 'Not possible',
  blockedTariff_body: 'A switch is not possible from the second insurance year onwards, as both tariffs offer unlimited annual maximum benefits.',
  blockedTariff_footer_pre: 'More information can be found in our',
  blockedTariff_footer_post: '.',
  "45PeriodNotice": "The selected date is outside the 45-day period.",
  confirmPet: 'Confirm Pet',
  changeBirthOrAdress: 'Customer birthday and email adress change',
  reactivateContract: 'Reactivate contract',
  changeAdminContract: 'Contract Change',
  CancellationOrRevocation: 'Contract termination',
  'The new premium amounts to': 'The new premium amounts to',
  dataChangedSuccess: 'Well done! Data record successfully changed!',
  removeDunnings: 'Remove dunnings',
  dunningsMenu: 'Dunnings',
  Dunnings: 'Dunnings',
  dunningsPageHeader: 'Open dunning cases',
  Comment: 'Comment',
  Showing: 'Showing',
  of: 'of',
  perPage: 'per page',
  All: 'All',
  Status: 'Status',
  Open: 'Open',
  'Open dunning cases flagged by the daily scan. Mark a case once you have reviewed it.':
    'Open dunning cases flagged by the daily scan. Mark a case once you have reviewed it.',
  'Search by policy number': 'Search by policy number',
  'Not confirmed': 'Not confirmed',
  Confirmed: 'Confirmed',
  Refresh: 'Refresh',
  Shown: 'Shown',
  Total: 'Total',
  'No open dunnings': 'No open dunnings',
  'Nothing matches this filter': 'Nothing matches this filter',
  'Due date': 'Due date',
  'Payment deadline': 'Payment deadline',
  'Cancel date': 'Cancel date',
  Processed: 'Processed',
  'Dunning marked as confirmed': 'Dunning marked as confirmed',
  'Confirmation removed': 'Confirmation removed',
  'Saving...': 'Saving...',
  'Policy Number': 'Policy Number',
  'Datenänderung': 'Change data',
  'Bestätigen': 'Confirm',
  'Bitte Rasse eintippen': 'Please select breed',
  'Please make a selection for reimbursement in your new tariff': 'Please make a selection for reimbursement in your new tariff',
  'kündigen': 'your',
  'widerrufen': 'your',
  badCoverage: 'No such coverage for this tariff',
  'When should the change be active?': 'When should the change be active?',
  'Change birthday/email address': 'Change birthday/email address',
  'Contract change': 'Contract change',
  'Cancellation/withdrawal': 'Cancellation/withdrawal',
  'Reactivate contract': 'Reactivate contract',
  'Change animal data': 'Change animal data',
  'Invalid MTA date. Must be a future date.': 'Invalid MTA date. Must be a future date.',
  'Policy not found!': 'Policy not found!',
  "Can't change to the same tariff/coverage.": "Can't change to the same tariff/coverage",
  'You have a pending operation on this policy!': 'You have a pending operation on this policy!',
  'Subscription is canceled.': 'Subscription is canceled.',
  'Ordinary termination customer': 'Ordinairy termination customer',
  'Well done! Contract successfully reactivated!': 'Well done! Contract successfully reactivated!',
  ordinary_cancelation: 'Ordinary termination customer',
  cancellation_for_other_reasons: 'Cancellation for other reasons',
  termination_claim_customer: 'Termination claim customer',
  termination_claim_insurer: 'Termination claim insurer',
  // New Termination Types
  revocation: 'Revocation',
  ordinary_termination_first_year: 'Ordinary termination customer first year',
  ordinary_termination_second_year_with_payment: 'Ordinary termination customer second year with payment',
  ordinary_termination_second_year_without_payment: 'Ordinary termination customer second year without payment',
  ordinary_cancelation_insurer: 'Ordinary termination insurer',
  loss_of_insured_interest_with_payment: 'Loss of insured interest with payment',
  loss_of_insured_interest_without_payment: 'Loss of insured interest without payment',
  termination_claim_customer_with_payment: 'Termination claim customer with payment',
  termination_claim_customer_without_payment: 'Termination claim customer without payment',
  termination_claim_insurer_with_payment: 'Termination claim insurer with payment',
  termination_claim_insurer_without_payment: 'Termination claim insurer without payment',
  withdrawal_by_the_insurer: 'Withdrawal',
  // End new termination types
  'Subscription is canceled': 'Subscription is canceled',
  'No IBAN': 'No IBAN',
  notificationDate: 'Notification date',
  pleaseSelectImage: 'Please select an image file.',
  showing: 'Showing',
  outOfTotal: 'records, out of total',
  noIban: "Customer has no IBAN",
  noCustomer: "Claim has no customer",
  hasNotificationDate: "Claim has no notification date",
  xmlErrorTitle: "Failed generating XML for claims:",
  missingFields: "missing fields",
  noNotificationDate: "Claim has no notification date",
  clearedReserves: "Claim has cleared reserves",
  enterMtaDate: 'Please enter MTA date',
  enterCustomerComment: 'Why did you go to the vet?',
  contractRevoked: 'Contract revoked',
  cannotUploadNewClaims: 'Unfortunately, you cannot upload any invoices for this contract, as the contract has been revoked.',
  upload: 'You can upload your invoices here',
  customerComment: 'Please explain the reason for your visit to the vet:',
  noAmountError: "Amount error",
  payeeError: "Payee error - multiple persons or missing IBAN in reserve decisions",
  claimPaymentsAreProcessing: "Claim payments are processing",
  checkInvoices: 'Check invoices',
  paymentPortal: 'Payment portal',
  manualPayments: 'Manual payments',
  manualPaymentsUpload: 'Upload CSV',
  manualPaymentsChooseFile: 'Choose file',
  manualPaymentsPrev: 'Previous',
  manualPaymentsFrom: 'From',
  manualPaymentsTo: 'To',
  manualPaymentsAnyUploader: 'Any uploader',
  manualPaymentsAnyStatus: 'Any status',
  manualPaymentsAnyRemaining: 'Any',
  manualPaymentsWithRemaining: 'With remaining',
  manualPaymentsWithoutRemaining: 'Fully allocated',
  manualPaymentsClearFilters: 'Clear',
  manualPaymentsNoMatches: 'Nothing matches these filters',
  manualPaymentsNext: 'Next',
  manualPaymentsRefresh: 'Refresh',
  manualPaymentsOpen: 'Open',
  manualPaymentsBackToUploads: 'Back to uploads',
  manualPaymentsFile: 'File',
  manualPaymentsUploadedBy: 'Uploaded by',
  manualPaymentsUploadedAt: 'Uploaded at',
  manualPaymentsRunStatus: 'Status',
  manualPaymentsRows: 'Allocated rows',
  manualPaymentsAmountTotal: 'Total',
  manualPaymentsAmountAllocated: 'Allocated',
  manualPaymentsAmountRemaining: 'Remaining',
  manualPaymentsNoUploads: 'No uploads yet',
  manualPaymentsNoRows: 'No rows in this upload',
  manualPaymentsBookingDate: 'Booking date',
  manualPaymentsPayer: 'Payer',
  manualPaymentsPolicyNo: 'Policy no.',
  manualPaymentsAmount: 'Amount',
  manualPaymentsAllocatedTo: 'Allocated to',
  manualPaymentsRowStatus: 'Status',
  manualPaymentsReason: 'Note',
  manualPaymentsPartialShort: 'partial',
  manualPaymentsFailedShort: 'failed',
  manualPaymentsDuplicateShort: 'duplicate',
  manualPaymentStatus_pending: 'Pending',
  manualPaymentStatus_processing: 'Processing',
  manualPaymentStatus_processed: 'Processed',
  manualPaymentStatus_allocated: 'Allocated',
  manualPaymentStatus_allocated_partial: 'Partly allocated',
  manualPaymentStatus_no_unpaid_installments: 'No open instalments',
  manualPaymentStatus_failed: 'Failed',
  manualPaymentStatus_duplicate: 'Duplicate',
  exportClaimTasks: 'Export claim tasks',
  exportClaimTasksConfirmText: 'Do you want to export claim tasks?',
  exportClaimTasksReadyText: 'Export generated successfully. You can download the file now.',
  downloadXlsx: 'Download XLSX',
  policies: 'Policies',
  invoices: 'Invoices',
  allocate: 'Allocate',
  charge: 'Charge',
  chargeSuccessful: 'Charge successful',
  chargeFailed: 'Charge failed',
  sendInvoice: 'Send Invoice',
  chargeConfirmTitle: 'Confirm Charge',
  sendInvoiceConfirmTitle: 'Confirm Send Invoice',
  chargeConfirmText: 'Are you sure you want to charge invoice {{invoiceNo}} for {{amount}} €?',
  sendInvoiceConfirmText: 'Are you sure you want to send invoice {{invoiceNo}} for {{amount}} €?',
  chargeResult: 'Charge Result',
  viewChargeInvoice: 'Invoice link',
  copiedToClipboard: 'Copied!',
  allocationSuccessful: 'Allocation successful',
  allocationFailed: 'Allocation failed',
  partialAllocationSuccess: '{{success}} allocation(s) successful, {{failed}} failed',
  backToPolicies: 'Back to policies',
  invoiceAlreadyPaid: 'Invoice already paid',
  xmlAlreadyGeneratedWarning: 'You`ve already generated the XML. Are you sure you want to generate it again?',
  online24title: 'Your 24-hour online veterinarian',
  online24subtitle: 'It\'s that easy',
  online24message: `Emergency - what now? With PANDA <span>comprehensive health insurance for dogs</span> or <span>comprehensive health insurance for cats</span>, you get unlimited access to the online vet Pfotendoctor in addition to free choice of veterinarian. This means you can seek veterinary help from home or on the go if necessary - even at night, on weekends, or on holidays.`,
  onlineCard1Title: 'Make an appointment',
  onlineCard2Title: 'Describe the problem',
  onlineCard3Title: 'Help and advice from the veterinarian',
  onlineCard1: `Visit <a href="https://www.pfotendoctor.de">www.pfotendoctor.de</a> and have your insurance number ready. Make an appointment and we will bill Pfotendoctor directly.`,
  onlineCard2: 'The veterinarians at Pfotendoctor have many years of practical experience and are usually available within minutes. Describe the problem during the video chat or upload photos.',
  onlineCard3: 'You will receive an assessment of the situation and may not need to go to the vet at all. In an emergency, you will be given the address of your nearest emergency service.',
  onlineButton: 'To 24h online vet',
  newEmailAddress: 'New email address',
  newBD: 'New birthday',
  financialInfo: 'Financial information',
  lastPaymentDate: 'Last payment date',
  terminatedAt: 'Terminated at',
  pendingStripePayments: 'Pending Stripe payments',
  stripeSubscription: 'Stripe subscription',
  loading: 'Loading...',
  
  // Status mappings: key is Insly status, value is { display: 'Display Name', tooltip: 'Tooltip message' }
  claimStatusMap: {
    'open - ready for automation': { display: 'Open', tooltip: 'Your claim has been successfully received by us.' },
    'open - ready for review': { display: 'In Progress', tooltip: 'Your claim is currently being processed.' },
    'open': { display: 'Open', tooltip: 'Your claim has been successfully received by us.' },
    'on hold - reply outstanding': { display: 'Awaiting Reply', tooltip: 'We have sent you a follow-up question and are waiting for your response.' },
    'on hold - premium not paid': { display: 'Premium Not Paid', tooltip: 'Your premium was not paid at the time of treatment.' },
    'in progress': { display: 'In Progress', tooltip: 'Your claim is currently being processed.' },
    'closed - payment released': { display: 'Payment Released', tooltip: 'Your claim has been approved for payment.' },
    'closed - rejection': { display: 'Rejected', tooltip: 'Your claim has been rejected. Further information can be found in the email.' },
    'closed - no customer respond': { display: 'No Response', tooltip: 'Your claim has been closed because we did not receive a response to our inquiry.' },
    'in Revision': { display: 'In Revision', tooltip: 'Your claim is currently under review.' },
    'reopened': { display: 'Reopened', tooltip: 'Your additional documents have been successfully added to the claim and are ready for processing.' },
    'Recovery created': { display: 'Recovery Started', tooltip: 'Recovery has been initiated.' },
    'Recovery settled': { display: 'Recovery Completed', tooltip: 'Recovery has been completed.' },
    'canceled': { display: 'Rejected', tooltip: 'Your claim has been rejected. Further information can be found in the email.' },
    'closed - payment issued': { display: 'Payment Issued', tooltip: 'Payment for your claim has been completed.' },
    'closed - incorrectly created': { display: 'Incorrectly Created', tooltip: 'The submitted invoices have been assigned to an existing claim.' },
    'closed - double submission': { display: 'Double Submission', tooltip: 'The invoice has already been processed in an existing claim.' },
    'closed - reply outstanding': { display: 'Awaiting Reply', tooltip: 'We have sent you a follow-up question and are waiting for your response.' },
  },
  Skipped: 'Skipped',
  Updated: 'Updated',
  cancelledPoliciesNotice: 'Please note that cancelled/terminated policies were not processed in this customer update.',
  paymentMethodDetails: 'Payment method details',
  paymentSource: 'Payment source',
  dateIssue: 'Issue date',
  stripeId: 'Stripe ID',
};




export const de = {
  stripeId: 'Stripe ID',
  dateIssue: 'Ausstellungsdatum',
  paymentSource: 'Zahlungsquelle',
  paymentMethodDetails: 'Zahlungsmethode Details',
  cancelledPoliciesNotice: 'Bitte beachten Sie, dass stornierte/gekündigte Policen in diesem Kundenupdate nicht verarbeitet wurden.',
  Skipped: 'Übersprungen',
  Updated: 'Aktualisiert',
  loading: 'Laden...',
  stripeSubscription: 'Stripe Abonnement',
  pendingStripePayments: 'Ausstehende Stripe-Zahlungen',
  terminatedAt: 'Terminiert am',
  lastPaymentDate: 'Letztes Zahlungsdatum',
  financialInfo: 'Finanzinformationen',
  newEmailAddress: 'Neue E-Mail-Adresse',
  newBD: 'Neues Geburtsdatum',
  onlineButton: 'Zum 24h Online Vet',
  onlineCard1Title: 'Termin vereinbaren',
  onlineCard2Title: 'Problem beschreiben',
  onlineCard3Title: 'Hilfe und Rat vom Tierarzt',
  onlineCard1: `Besuchen Sie <a href="https://www.pfotendoctor.de">www.pfotendoctor.de</a> und halten Sie Ihre Versicherungsnummer bereit. Vereinbaren Sie einen Termin und wir rechnen direkt mit Pfotendoctor ab.`,
  onlineCard2: 'Die Tierärzte von Pfotendoctor haben langjährige Praxiserfahrung und sind meist binnen weniger Minuten verfügbar. Schildern Sie beim Videochat das Problem oder laden Sie Fotos hoch.',
  onlineCard3: 'Sie erhalten eine Einschätzung der Situation und müssen vielleicht gar nicht zum Tierarzt fahren. Im Ernstfall bekommen Sie die Adresse Ihres nächstgelegenen Notdienstes.',
  online24title: 'Ihr 24h Online Tierarzt',
  online24subtitle: 'so einfach geht\'s',
  online24message: `Notfall - was nun? Im PANDA <span>Krankenvollschutz für Hunde</span> und dem <span>Krankenvollschutz für Katzen</span> erhalten Sie zusätzlich zur freien Tierarztwahl unlimitierten Zugang zum Online Vet Pfotendoctor. So können Sie im Bedarfsfall von Zuhause oder unterwegs tierärztliche Hilfe einholen - auch nachts, am Wochenende oder an Feiertagen.`,
  xmlAlreadyGeneratedWarning: 'Sie haben die XML-Datei bereits erstellt. Sind Sie sicher, dass Sie sie erneut erstellen möchten?',
  invoiceAlreadyPaid: 'Rechnung bereits bezahlt',
  backToPolicies: 'Zurück zu den Verträge',
  allocationSuccessful: 'Zuweisung erfolgreich',
  allocationFailed: 'Zuweisung fehlgeschlagen',
  partialAllocationSuccess: '{{success}} Zuweisung(en) erfolgreich, {{failed}} fehlgeschlagen',
  allocate: 'Zuweisen',
  charge: 'Belasten',
  chargeSuccessful: 'Belastung erfolgreich',
  chargeFailed: 'Belastung fehlgeschlagen',
  sendInvoice: 'Rechnung senden',
  chargeConfirmTitle: 'Belastung bestätigen',
  sendInvoiceConfirmTitle: 'Rechnungsversand bestätigen',
  chargeConfirmText: 'Möchten Sie die Rechnung {{invoiceNo}} über {{amount}} € wirklich belasten?',
  sendInvoiceConfirmText: 'Möchten Sie die Rechnung {{invoiceNo}} über {{amount}} € wirklich senden?',
  chargeResult: 'Belastungsergebnis',
  viewChargeInvoice: 'Rechnungslink',
  copiedToClipboard: 'Kopiert!',
  policies: 'Verträge',
  invoices: 'Rechnungen',
  paymentPortal: 'Zahlungsportal',
  manualPayments: 'Manuelle Zahlungen',
  manualPaymentsUpload: 'CSV hochladen',
  manualPaymentsChooseFile: 'Datei wählen',
  manualPaymentsPrev: 'Zurück',
  manualPaymentsFrom: 'Von',
  manualPaymentsTo: 'Bis',
  manualPaymentsAnyUploader: 'Alle Benutzer',
  manualPaymentsAnyStatus: 'Alle Status',
  manualPaymentsAnyRemaining: 'Alle',
  manualPaymentsWithRemaining: 'Mit Restbetrag',
  manualPaymentsWithoutRemaining: 'Vollständig zugeordnet',
  manualPaymentsClearFilters: 'Zurücksetzen',
  manualPaymentsNoMatches: 'Keine Treffer für diese Filter',
  manualPaymentsNext: 'Weiter',
  manualPaymentsRefresh: 'Aktualisieren',
  manualPaymentsOpen: 'Öffnen',
  manualPaymentsBackToUploads: 'Zurück zu den Uploads',
  manualPaymentsFile: 'Datei',
  manualPaymentsUploadedBy: 'Hochgeladen von',
  manualPaymentsUploadedAt: 'Hochgeladen am',
  manualPaymentsRunStatus: 'Status',
  manualPaymentsRows: 'Zugeordnete Zeilen',
  manualPaymentsAmountTotal: 'Gesamt',
  manualPaymentsAmountAllocated: 'Zugeordnet',
  manualPaymentsAmountRemaining: 'Offen',
  manualPaymentsNoUploads: 'Noch keine Uploads',
  manualPaymentsNoRows: 'Keine Zeilen in diesem Upload',
  manualPaymentsBookingDate: 'Buchungstag',
  manualPaymentsPayer: 'Zahlungsbeteiligter',
  manualPaymentsPolicyNo: 'Policennummer',
  manualPaymentsAmount: 'Betrag',
  manualPaymentsAllocatedTo: 'Zugeordnet auf',
  manualPaymentsRowStatus: 'Status',
  manualPaymentsReason: 'Hinweis',
  manualPaymentsPartialShort: 'teilweise',
  manualPaymentsFailedShort: 'fehlgeschlagen',
  manualPaymentsDuplicateShort: 'Duplikat',
  manualPaymentStatus_pending: 'Ausstehend',
  manualPaymentStatus_processing: 'In Bearbeitung',
  manualPaymentStatus_processed: 'Verarbeitet',
  manualPaymentStatus_allocated: 'Zugeordnet',
  manualPaymentStatus_allocated_partial: 'Teilweise zugeordnet',
  manualPaymentStatus_no_unpaid_installments: 'Keine offenen Raten',
  manualPaymentStatus_failed: 'Fehlgeschlagen',
  manualPaymentStatus_duplicate: 'Duplikat',
  exportClaimTasks: 'Claim-Aufgaben exportieren',
  exportClaimTasksConfirmText: 'Möchten Sie die Claim-Aufgaben exportieren?',
  exportClaimTasksReadyText: 'Export erfolgreich erstellt. Sie können die Datei jetzt herunterladen.',
  downloadXlsx: 'XLSX herunterladen',
  checkInvoices: 'Rechnungen prüfen',
  claimPaymentsAreProcessing: "Die Auszahlung der Ansprüche wird bearbeitet.",
  noAmountError: "Betragsfehler",
  payeeError: "Zahlungsempfängerfehler - mehrere Personen oder fehlende IBAN in Reservierungsentscheidungen",
  clearedReserves: "Anspruch hat Reserven aufgelöst",
  noNotificationDate: "Kein Benachrichtigungsdatum",
  xmlErrorTitle: "Fehler beim Erstellen der XML-Datei für Forderungen:",
  missingFields: "fehlende Felder",
  noIban: "Kunde hat keine IBAN",
  noCustomer: "Die Forderung hat keinen Kunden",
  hasNotificationDate: "Die Forderung hat kein Benachrichtigungsdatum",
  showing: 'Es werden',
  outOfTotal: 'datensätze angezeigt, von insgesamt',
  pleaseSelectImage: 'Bitte wählen Sie eine Bilddatei aus.',
  notificationDate: 'Benachrichtigungsdatum',
  'No IBAN': 'Keine IBAN',
  'Subscription is canceled': 'Das Abonnement wird gekündigt',
  termination_claim_insurer: 'Kündigung im Leistungsfall Versicherer',
  termination_claim_customer: 'Kündigung im Leistungsfall Versicherungsnehmer',
  cancellation_for_other_reasons: 'Kündigung aus sonstigen Gründen',
  ordinary_cancelation: 'Ordentliche Kündigung Versicherungsnehmer',
  // New termination types
  revocation: 'Widerruf Versicherungsnehmer',
  ordinary_termination_first_year: 'Ordentliche Kündigung Versicherungsnehmer 1. Jahr',
  ordinary_termination_second_year_with_payment: 'Ordentliche Kündigung Versicherungsnehmer ab 2. Jahr MIT Zahlung',
  ordinary_termination_second_year_without_payment: 'Ordentliche Kündigung Versicherungsnehmer ab 2. Jahr OHNE Zahlung',
  ordinary_cancelation_insurer: 'Ordentliche Kündigung Versicherer',
  loss_of_insured_interest_with_payment: 'Wegfall des versicherten Interesses MIT Zahlung',
  loss_of_insured_interest_without_payment: 'Wegfall des versicherten Interesses OHNE Zahlung',
  termination_claim_customer_with_payment: 'Kündigung im Leistungsfall Versicherungsnehmer MIT Zahlung',
  termination_claim_customer_without_payment: 'Kündigung im Leistungsfall Versicherungsnehmer OHNE Zahlung',
  termination_claim_insurer_with_payment: 'Kündigung im Leistungsfall Versicherer MIT Zahlung',
  termination_claim_insurer_without_payment: 'Kündigung im Leistungsfall Versicherer OHNE Zahlung',
  withdrawal_by_the_insurer: 'Rücktritt vom Vertrag Versicherer',
  // End new termiation types
  'Well done! Contract successfully reactivated!': 'Gut gemacht! Vertrag erfolgreich reaktiviert!',
  'Ordinary termination customer': 'Ordentliche Kündigung Versicherungsnehmer',
  'Subscription is canceled.': 'Das Abonnement wurde gekündigt.',
  'You have a pending operation on this policy!': 'Sie haben einen schwebenden Vorgang für diese Police!',
  "Can't change to the same tariff/coverage.": "Kann nicht in denselben Tarif/Deckung wechseln.",
  'Policy not found!': 'Richtlinie nicht gefunden!',
  'Invalid MTA date. Must be a future date.': 'Ungültiges MTA-Datum. Muss ein zukünftiges Datum sein.',
  'Change animal data': 'Tierdaten ändern',
  'Reactivate contract': 'Vertrag reaktivieren',
  'Cancellation/withdrawal': 'Kündigung/Rücktritt',
  'Contract change': 'Vertragsänderung',
  'Change birthday/email address': 'Geburtstag/E-Mail-Adresse ändern',
  'When should the change be active?': 'Ab wann soll die Änderung aktiv sein?',
  badCoverage: 'Keine derartige Deckung für diesen Tarif',
  'widerrufen': 'widerrufen',
  'kündigen': 'kündigen',
  'Please make a selection for reimbursement in your new tariff': 'Bitte treffen Sie eine Auswahl zur Kostenerstattung in Ihrem neuen Tarif',
  'Bitte Rasse eintippen': 'Bitte Rasse eintippen',
  'Bestätigen': 'Bestätigen',
  'Datenänderung': 'Datenänderung',
  dataChangedSuccess: 'Gut gemacht! Datensatz erfolgreich geändert!',
  'Policy Number': 'Versicherungsnummer',
  removeDunnings: 'Mahnungen entfernen',
  dunningsMenu: 'Mahnungen',
  Dunnings: 'Mahnungen',
  dunningsPageHeader: 'Offene Mahnvorgänge',
  Comment: 'Kommentar',
  Showing: 'Angezeigt',
  of: 'von',
  perPage: 'pro Seite',
  All: 'Alle',
  Status: 'Status',
  Open: 'Offen',
  'Open dunning cases flagged by the daily scan. Mark a case once you have reviewed it.':
    'Offene Mahnvorgänge aus dem täglichen Lauf. Markiere einen Vorgang, sobald Du ihn geprüft hast.',
  'Search by policy number': 'Nach Versicherungsnummer suchen',
  'Not confirmed': 'Nicht bestätigt',
  Confirmed: 'Bestätigt',
  Refresh: 'Aktualisieren',
  Shown: 'Angezeigt',
  Total: 'Gesamt',
  'No open dunnings': 'Keine offenen Mahnungen',
  'Nothing matches this filter': 'Keine Treffer für diesen Filter',
  'Due date': 'Fälligkeitsdatum',
  'Payment deadline': 'Zahlungsfrist',
  'Cancel date': 'Kündigungsdatum',
  Processed: 'Verarbeitet',
  'Dunning marked as confirmed': 'Mahnung als bestätigt markiert',
  'Confirmation removed': 'Bestätigung entfernt',
  'Saving...': 'Wird gespeichert...',
  pleaseSelectTariff: 'Bitte wählen Sie einen Tarif',
  blockedTariff_title: 'Nicht möglich',
  blockedTariff_body: 'Ein Wechsel ist ab dem zweiten Versicherungsjahr nicht möglich, da beide Tarife eine unbegrenzte Jahreshöchstleistung enthalten.',
  blockedTariff_footer_pre: 'Mehr Informationen findest Du in unseren',
  blockedTariff_footer_post: '.',
  option_noClaims:
    'Bisher keine Leistung (Schaden) erfolgt und das Tier  ist gesund',
  option_noClaimsSixMonths:
    'Bereits eine tierärztliche Behandlung (außer Prävention) erfolgt, diese liegt länger als 6 Monate zurück und das Tier ist jetzt gesund',
  option_wasClaimed:
    'Bereits eine Leistung außer Prävention erfolgt, welche nicht länger als 6 Monate zurückliegt bzw. das Tier ist nicht gesund',
  pleaseAnswerTruthfully:
    'Bitte beantworten Sie folgende Fragen wahrheitsgemäß',
  placeholder_1: 'Geben Sie HIER Ihre Anfrage ein.',
  thankYouMessage_changeDeductible: `Vielen Dank,</br></br>wir leiten Ihren Änderungswunsch weiter.</br>Wir melden uns bei Ihnen, wenn die Änderung durchgeführt wurde.</br></br>Das PANDA Team wünscht einen schönen Tag!`,
  thankYouMessage_otherEnquiry: `Vielen Dank,</br></br>Ihre Anfrage ist bei uns eingegangen.</br>Wir melden uns so rasch als möglich bei Ihnen zurück.</br></br>Das PANDA Team wünscht einen schönen Tag!`,
  pleaseConfirmRequest: 'Bitte bestätigen Sie Ihren Änderungswunsch',
  changeEffectiveFrom: 'Ihre Änderung ist aktiv ab',
  whenShouldChange: 'Ab wann soll die Änderung aktiv sein?',
  yourNewPremiumIs: 'Ihre neue Prämie beträgt',
  changeDeductibleTo: 'Selbstbehalt ändern auf',
  otherEnquiry: 'Andere Anfrage',
  changeTariff: 'Tarifwechsel anfordern',
  'The new premium amounts to': 'Die neue Prämie beträgt',
  change_tariff: 'Tarifwechsel',
  changeDeductible: 'Selbstbehalt ändern',
  whatToChange: 'Was möchten Sie tun?',
  dog: 'Hund',
  cat: 'Katze',
  pureBreed: 'Reinrassig',
  hybridBeed: 'Mischling',
  unknownBeed: 'Unbekannt',
  'Cat habitat': 'Wohnort meiner Katze',
  'Dog height': 'Größe meines Hundes',
  'Pet gender': 'Geschlecht meines Tieres',
  'Pet chipnumber': 'Chipnummer meines Tieres',
  'Pet birthday': 'Geburtsdatum meines Tieres',
  'Pet breed': 'Rasse meines Tieres',
  'Pet name': 'Name meines Tieres',
  reactivateContract: 'Vertrag reaktivieren',
  thankYouNoMessage: `Wir sehen, dass Sie die Änderung nicht durchführen möchten. Der Vertrag wird wie bisher weitergeführt.<br/><br/>Bei Rückfragen wenden Sie sich gerne jederzeit an unseren Kundenservice!`,
  thankYouYesMessage: `Vielen Dank,<br/><br/>wir haben Ihren Änderungswunsch zur Durchführung erhalten. Diese ist nun bei uns in Bearbeitung. Sie erhalten in Kürze eine Bestätigung an die in Ihrem Vertrag hinterlegte Emailadresse.<br/><br/>Wir wünschen Ihnen und Ihrem Vierbeiner alles Gute!`,
  changeBreedMessage:
    'Möchten Sie den Vorgang nun abschließen? Wir weisen Sie darauf hin, dass eine Änderung des Rasse den Preis Ihrer Versicherung beeinflussen kann.',
  changeBDMessage:
    'Möchten Sie den Vorgang nun abschließen? Wir weisen Sie darauf hin, dass eine Änderung des Geburtsdatums den Preis Ihrer Versicherung beeinflussen kann.',
  changeHabitatMessage:
    'Möchten Sie den Vorgang nun abschließen? Wir weisen Sie darauf hin, dass eine Änderung des Wohnortes den Preis Ihrer Versicherung beeinflussen kann.',
  changeHeightMessage:
    'Möchten Sie den Vorgang nun abschließen? Wir weisen Sie darauf hin, dass eine Änderung der Größe den Preis Ihrer Versicherung beeinflussen kann.',
  Outdoor: 'Freigänger',
  Indoor: 'Hauskatze',
  pleaseSelectCatHabitat: 'Bitte geben Sie hier den Wohnort Ihrer Katze an.',
  pleaseSelectDogHeight: 'Bitte geben Sie hier die Größe Ihres Tieres an.',
  pleaseEnterPetBD: 'Bitte geben Sie hier den Geburtstag Ihres Tieres ein.',
  pleaseEnterPetChip:
    'Bitte geben Sie hier die korrekte Chipnummer Ihres Tieres ein.',
  pleaseSelectPetGender: 'Bitte geben Sie hier das Geschlecht Ihres Tieres an.',
  pleaseSelectBreedType: 'Bitte wählen Sie die Rasse Ihres Tieres aus',
  pleaseSelectPetType: 'Um welches Tier handelt es sich?',
  pleaseEnterPetName:
    'Bitte geben Sie hier den gewünschten Namen Ihres Tieres ein.',
  pleaseSelectHere: 'Bitte hier auswählen',
  whichPetDataToChange: 'Welche Tierdaten möchten Sie ändern?',
  catHabitatChange: 'Wohnort meiner Katze',
  dogHeightChange: 'Größe des Hundes',
  petGenderChange: 'Geschlecht des Tieres',
  petChipChange: 'Chipnummer des Tieres',
  petBDChange: 'Geburtstag des Tieres',
  petBreedChange: 'Rasse des Tieres',
  petNameChange: 'Name des Tieres',
  male: 'Männlich',
  female: 'Weiblich',
  iban: 'IBAN',
  Change_deductible: 'Selbstbehalt ändern',
  event: 'Veranstaltung',
  hasOverdue: 'Ist überfällig',
  pleaseFillInputs: 'Bitte fülle alle Pflichtfelder aus.',
  Kundenservice: 'Kundenservice',
  chipHere: 'Geben Sie hier die Chipnummer ein',
  Leistungsfallabteilung: 'Leistungsfallabteilung',
  enterChipBefore:
    'Bevor Sie einen Leistungsfall melden können, müssen Sie die Chipnummer Ihres Tieres bekanntgeben.',
  requestSent: 'Anfrage wurde gesendet',
  noteReporOnlytWithChip:
    'Bitte beachten Sie, dass Sie erst einen Leistungsfall melden können, wenn Sie die Chipnummer Ihres Vierbeiners angegeben haben.',
  pleaseEnterChip: 'Bitte Chipnummer nachtragen',
  chipShould15: 'Die Chipnummer muss 15 Stellen enthalten',
  attentionNoChip: 'Achtung! Chipnummer fehlt',
  open: 'offen',
  'in progress': 'in Bearbeitung',
  'closed - payment released': 'Zahlung veranlasst',
  'closed - rejection': 'geschlossen',
  'closed - no customer respond': 'keine Kundenrückmeldung',
  'closed - payment issued': 'Zahlung freigegeben',
  reopened: 'wiedereröffnet',
  'Recovery created': 'Regress',
  'Recovery settled': 'Regress',
  canceled: 'storniert',
  paymentMethodSuccessfullyUpdated: 'Zahlungsmethode erfolgreich aktualisiert',
  savePaymentMethod: 'Zahlungsmethode speichern',
  Payments: 'Zahlungen',
  subInvTotal: 'Gesamtsumme / Rechnungsbetrag',
  subInvTotalMob: 'Gesamtsumme /\nRechnungsbetrag',
  Refunds: 'Erstattungen',
  unsupportedFileSize: ' Dateigröße ist zu groß',
  "30PeriodNotice": "Das ausgewählte Datum liegt außerhalb der 30 Tage Frist.",
  "45PeriodNotice": "Das ausgewählte Datum liegt außerhalb der 45 Tage Frist.",
  unsupportedFileExtension: ' ist keine unterstützte Dateierweiterung.',
  unsupportedFileExtensionMessage: 'Dies ist keine unterstützte Dateierweiterung.',
  '(bei Unfällen 1.000€)': '(bei Unfällen 1.000€)',
  '(bei Unfällen 2.000€)': '(bei Unfällen 2.000€)',
  '(bei Unfällen 15.000€)': '(bei Unfällen 15.000€)',
  'bei Unfällen unbegrenzt': '(bei Unfällen unbegrenzt)',
  createdXMLok: 'XML-Datei erstellt',
  paymentsCreate: 'Zahlungen erstellt',
  processPayment: 'Zahlung verarbeiten',
  numberOfClaims: 'Anzahl der Ansprüche',
  noPoliciesFound: 'Es wurde keine Politik gefunden',
  noInvoicesFound: 'Keine Rechnungen gefunden',
  linkToInsly: 'Link zu Insly',
  customer: 'Kunde',
  createXML: 'XML-Datei erstellen',
  confirmPet: 'Tier bestätigen',
  date_on_contract_is_to_be_reactivated:
    'Wähle das Datum an dem der Vertrag reaktiviert werden soll',
  processXML: 'XML verarbeiten',
  generatePayments: "Zahlungen generieren",
  exportExcel: 'EXCEL exportieren',
  paymentPage: 'Zahlungsseite',
  paymentPeriod: 'Zahlungszeitraum',
  paymentAmount: 'Zahlungsbetrag',
  paymentDetails: 'Zahlungsdetails',
  paymentStatus: 'Zahlungsstatus',
  paymentDate: 'Zahlungsdatum',
  selectPaymentDate: 'Zahlungsdatum auswählen',
  selectPaymentDateText: 'Bitte wählen Sie ein Zahlungsdatum für diese Rechnung:',
  pleaseSelectPaymentDate: 'Bitte wählen Sie zuerst ein Zahlungsdatum für diese Rechnung aus',
  'sofort bei Unfällen': '(sofort bei Unfällen)',
  readClaimFail_start:
    'Die Rechnung konnte nicht gelesen werden, bitte senden Sie sie an ',
  readClaimFail_end: ' und aktualisieren Sie die Seite.',
  'OP Basic': 'OP-Schutz Basis',
  'OP Comfort': 'OP-Schutz Komfort',
  'OP Full': 'OP-Schutz Exklusiv',
  'Health Basic': 'Krankenvollschutz Basis',
  'Health Comfort': 'Krankenvollschutz Komfort',
  'Health Full': 'Krankenvollschutz Exklusiv',
  '70€ je Vers. Jahr': '70€ je Vers. Jahr',
  'keine besondere Wartezeit': 'Keine besondere Wartezeit',
  Bandscheibenvorfall: 'Bandscheibenvorfall',
  Bandscheibenvorfälle: 'Bandscheibenvorfälle',
  'Epiliepsie/Krampfanfälle': 'Epiliepsie/Krampfanfälle',
  'Nickhautdrüsenvorfall/Cherry Eye': 'Nickhautdrüsenvorfall/Cherry Eye',
  Niereninsuffizienz: 'Niereninsuffizienz',
  Pankreatitis: 'Pankreatitis',
  'Termination claim customer':
    'Kündigung im Leistungsfall Versicherungsnehmer',
  Kreuzbandrisse: 'Kreuzbandrisse',
  'Ordinairy termination insurer': 'Ordentliche Kündigung Versicherer',
  'Termination claim insurer': 'Kündigung im Leistungsfall Versicherer',
  'Withdrawal insurer': 'Rücktritt vom Vertrag Versicherer',
  'Onkologische Krankheiten (bösartige Tumore)':
    'Onkologische Krankheiten (bösartige Tumore)',
  'Onkologische Krankheiten (gutartige Tumore)':
    'Onkologische Krankheiten (gutartige Tumore)',
  'Onkologische Krankheiten (gutartige und bösartige Tumore)':
    'Onkologische Krankheiten (gutartige und bösartige Tumore)',
  'Erkrankungen, die vor Versicherungsbeginn oder in der Wartezeit bekannt/diagnostiziert waren':
    'Erkrankungen, die vor Versicherungsbeginn oder in der Wartezeit bekannt/diagnostiziert waren',
  'Hüftgelenksdysplasie (HD)': 'Hüftgelenksdysplasie (HD)',
  'Ellenbogendysplasie (ED)': 'Ellenbogendysplasie (ED)',
  'Hüftgelenksdysplasie (HD), Ellenbogendysplasie (ED)': `Hüftgelenksdysplasie (HD),\nEllenbogendysplasie (ED)`,
  'Osteochondrosis dissecans (OCD)': 'Osteochondrosis dissecans (OCD)',
  'Frakturierter Processus Coronoideus (FPC)':
    'Frakturierter Processus Coronoideus (FPC)',
  'Isolierter Processus Anconaeus (IPA)':
    'Isolierter Processus Anconaeus (IPA)',
  'Radius Curvus (Short-Ulna-Syndrom)': 'Radius Curvus (Short-Ulna-Syndrom)',
  Herzerkrankungen: 'Herzerkrankungen',
  'Erworbene Herzerkrankungen und Allergien':
    'Erworbene Herzerkrankungen und Allergien',
  Allergien: 'Allergien',
  'Schilddrüsenerkrankungen bei Hunden': 'Schilddrüsenerkrankungen bei Hunden',
  'Goldakupunktur bzw. Prothesen/Implantate':
    'Goldakupunktur bzw. Prothesen/Implantate',
  Kryptorchismus: 'Kryptorchismus',
  Entropium: 'Entropium',
  Ektropium: 'Ektropium',
  'Cherry-Eye/Nickhautdrüsenvorfall': 'Cherry-Eye/Nickhautdrüsenvorfall',
  Prothesen: 'Prothesen',
  'Cherry-Eye': 'Cherry-Eye',
  Nabelbruch: 'Nabelbruch',
  Arthrosen: 'Arthrosen',
  Kreuzbandriss: 'Kreuzbandriss',
  'Brachyzephales Syndrom': 'Brachyzephales Syndrom',
  Patellaluxation: 'Patellaluxation',
  Dackellähmung: 'Dackellähmung',
  Epilepsie: 'Epilepsie',
  'Epilepsie / Krampfanfälle': 'Epilepsie / Krampfanfälle',
  'Polyzistische Nierenerkrankung (PKD)':
    'Polyzistische Nierenerkrankung (PKD)',
  'Spinale Muskelatrophie (SMA)': 'Spinale Muskelatrophie (SMA)',
  'Mucopolysaccharidose (MPS VI)': 'Mucopolysaccharidose (MPS VI)',
  Anaplasmose: 'Anaplasmose',
  'Wobbler-Syndrom': 'Wobbler-Syndrom',
  'Niereninsuffizienz/Nierensteine': 'Niereninsuffizienz/Nierensteine',
  'Nur für Katzen: Schilddrüsenerkrankungen': 'Nur für Katzen: Schilddrüsenerkrankungen',
  'Herzerkrankungen, Allergien': 'Herzerkrankungen, Allergien',
  'Erworbene Herzerkrankungen und Allergien, Unverträglichkeiten und Atopie': 'Erworbene Herzerkrankungen und Allergien, Unverträglichkeiten und Atopie',
  'FORL/CORL': 'FORL/CORL',
  'Canine/Feline Vector Borne Diseases (CVBD/FVBD)':
    'Canine/Feline Vector Borne Diseases (CVBD/FVBD)',
  'Gilt nur für Katzen:': 'Gilt nur für Katzen:',
  day_30: '30 Tage',
  day_20: '20 Tage',
  month_1: '1 Monat',
  day_5: '5 Tage',
  day_14: '14 Tage',
  unlim: 'unbegrenzt',
  no_waiting_time: 'keine Wartezeit',
  nothingToChange:
    'Leider können Sie die Angaben zu Ihrem Haustier nicht selbst ändern.',
  analyzeClaim: 'Forderung analysieren',
  readClaim: 'Anspruch lesen',
  quarter: 'Vierteljahr',
  halfYear: 'Halbjahr',
  year: 'Jahr',
  Male: 'Herr',
  Female: 'Frau',
  diverse: 'Divers',
  yourDocuments: 'Ihre Dokumente',
  invoiceLink: 'Link zur Rechnung',
  policyReactivate: 'Politik reaktivieren',
  customerChanged: '*Durchgeführte Kundenänderungen',
  datePlaceholder: 'TT.MM.JJJJ',
  addDescr: 'Beschreibung hinzufügen',
  claimLC: 'Anspruch auf Haftpflichtversicherung',
  detailedView: 'Detailansicht',
  coverage: 'Kostenersatz',
  submittedOn: 'eingereicht am ',
  submittedDocs: 'Eingereichte Dokumente',
  tariff: 'Tarif',
  ContractInformation: 'Informationen zum Vertrag',
  Unknown: 'Unbekannt',
  submissionDate: 'Datum der Einreichung',
  sendChangeRequest: 'Änderungen speichern',
  loadingFlowText: 'Bitte warten Sie einen kurzen Moment...',
  maxRequstLimitReached:
    "Votre dernière demande n'a pas encore été traitée, veuillez réessayer plus tard.",
  successfullyUpdated: 'Erfolgreich aktualisiert!',
  errorReloading: 'Fehler, neu laden...',
  somethingWentWrong:
    'Etwas ist schief gelaufen! Bitte versuchen Sie es später noch einmal.',
  containPrevent: 'Enthält es Prävention:',
  isItDupl: 'Ist es ein Duplikat:',
  isItPolicyDR: 'Ist es der Datumsbereich der Police:',
  wasDiagOnInvoice: 'Wurde die Diagnose im Leistungsfall gestellt:',
  wasChipOnInvoice: 'War Chipnmuber auf dem Leistungsfall:',
  claimChecks: 'Leistungskontrolle',
  noClaimsToAdd: 'Sie haben bis jetzt noch keinen Leistungsfall hinzugefügt.',
  needChip:
    'Wir benötigen zur Prüfung Deines Leistungsfalls eine Chipnummer. Bitte lass die Chipnummer vom Tierarzt ergänzen und lade das Dokument danach erneut hoch.',
  needChipYes:
    'Bitte beantrage eine Änderung der Chipnummer Deines Tieres im Kundenportal.',
  needChipNo_inv:
    'Bitte kontaktiere Deine Tierarztpraxis und bitte um Ausstellung einer korrigierten Rechnung mit der richtigen Chipnummer Deines Tieres. Bitte reiche die korrigierte Rechnung dann erneut ein.',
  needChipNo_doc:
    'Bitte kontaktiere Deine Tierarztpraxis und bitte um Ausstellung einer korrigierten Dokument mit der richtigen Chipnummer Deines Tieres. Bitte reiche die korrigierte Dokument dann erneut ein.',
  needDiag_inv:
    'Wir benötigen zur Prüfung Ihres Leistungsfalls eine Diagnose. Bitte lassen Sie die Diagnose vom Tierarzt ergänzen und laden Sie die Rechnung danach erneut hoch.',
  needDiag_doc:
    'Wir benötigen zur Prüfung Ihres Leistungsfalls eine Diagnose. Bitte lassen Sie die Diagnose vom Tierarzt ergänzen und laden Sie das Dokument danach erneut hoch.',
  needDiag_EC:
    'Du hast Diagnose nachreichen ausgewählt und im nächsten Schritt bestätigt, dass auf dem Dokument keine Diagnose vorhanden ist. Bitte lass die Diagnose vom Tierarzt ergänzen und lade das Dokument danach erneut hoch.',
  Unbekannt: 'Unbekannt',
  'Logout as user': 'Als Benutzer abmelden',
  noteScreenshot:
    'Bitte beachten Sie, dass der Screenshot der Seite automatisch erstellt wird.',
  ticketConfirmed: 'Ticket erstellt',
  page: 'Seite',
  petPage: 'Seite für Haustiere',
  enhancements: 'Erweiterungen',
  error: 'Fehler',
  bug: 'Bug',
  ticket: 'Ticket',
  createTicket: 'Ticket erstellen',
  Submit: 'Einreichen',
  LoginAsUser: 'Melden Sie sich als Benutzer an',
  achtungChip: '*Achtung, Ihre Rechnung muss eine Chipnummer beinhalten!',
  achtungChip_GtV:
    'Bitte achten Sie darauf, dass die Rechnung vollständig lesbar ist und nicht verdeckt wird (z.B. Kassabon, Finger, Schatten etc.)',
  achtungChip_CE:
    '*Achtung, Ihr Kostenvoranschlag muss eine Chipnummer beinhalten!',
  uploadInvoiceLimit: 'Das Hochladen ist auf ein Dokument beschränkt. Sollte Ihre Rechnung aus mehreren Seiten bestehen, laden Sie diese bitte als PDF hoch. Besteht Ihre Rechnung aus nur einer Seite, können Sie diese auch als Foto hochladen. Weitere Rechnungen zum selben Behandlungsfall können im Anschluss als Nachreichung hochgeladen werden.',
  achtung: 'Achtung!',
  thankYouPageIngo:
    'Möglicherweise stellt sich bei der Rechnungsprüfung heraus, dass wir nicht alle vom Tierarzt verrechneten Beträge in voller Höhe bezahlen können, weil sie in Ihrem Vertrag nicht oder nicht in voller Höhe gedeckt sind (z.B. Selbstbeteiligung oder Jahreshöchstleistung). Nach erfolgter Rechnungsprüfung erhälten Sie von uns eine Aufstellung über die direktverrechneten Beträge. Falls wir die Rechnung nicht in voller Höhe bezahlen konnten, teilen wir Ihnen den von Ihnen an den Tierarzt zu erstattenden Betrag mit.',
  duplicateTo: 'Duplizieren nach: ',
  docPreview: 'Dokumentvorschau',
  'Existing Claim_': 'Bestehende Leistungsfall',
  General_: 'Rechnung',
  'General to Vets_': 'Direktverrechnung mit Tierarzt/Tierklinik',
  'Liability claim_': 'Haftpflichtschaden',
  'Cost estimation_': 'Kostenvoranschlag',
  claimType: 'Art der Leistungsfalles',
  document: 'Dokument',
  Document: 'Dokument',
  chipWrong: 'Falsche Chipnummer. Sie muss 15 Ziffern enthalten.',
  emailWrong: 'Falsche E-Mail.',
  confirmEmailWrong:
    'Bitte überprüfen Sie Ihre E-Mail und Ihre Bestätigungs-E-Mail. Sie stimmen nicht überein.',
  addLine: 'Zeile hinzufügen',
  deleteLine: 'Zeile löschen',
  Payment: 'Zahlung',
  paymentDescription: 'An welches Konto sollen wir die Zahlung überweisen?',
  paymentTile: 'Gewünschtes Konto für Überweisung',
  'Your benefit cases': 'Deine Leistungsfälle',
  'Welches Dokument möchten Sie nachreichen?':
    'Welches Dokument möchten Sie nachreichen?',
  confirmChangeData_3: 'Das PANDA Team wünscht einen schönen Tag!',
  confirmChangeData_2:
    'wir haben Ihren Änderungswunsch zur Durchführung erhalten. Diese ist nun bei uns in Bearbeitung. Sie erhalten in Kürze eine Bestätigung an die in Ihrem Vertrag hinterlegte Emailadresse',
  confirmChangeData_1: 'Vielen Dank,',
  doesBelongExistingClaim1: 'Gehört die ',
  doesBelongExistingClaim1_CE: 'Gehört der ',
  doesBelongExistingClaim2: ' zu einem bereits bestehenden Leistungsfall?',
  reportLiab: 'Haftpflichtschaden melden',
  costEstimation: 'Kostenvoranschlag',
  CostEstimation: 'Kostenvoranschlag',
  adjudication: 'Empfehlungen zur Adjudikation',
  seeAdvice: 'Siehe Ratschläge',
  loaderSubText2:
    'Wir verarbeiten gerade Ihr Dokument, dies kann einige Momente in Anspruch nehmen…',
  loaderSubText_CE: 'Ihr Kostenvoranschlag wird gerade hochgeladen.',
  loaderSubText: 'Ihre Dokumente werden gerade hochgeladen.',
  loaderText: 'Bitte warten Sie einen kurzen Moment',
  nowProcessed_CE:
    'Dieser ist nun bei uns in Bearbeitung und wir melden uns in Kürze bei Ihnen.',
  nowProcessed_LC:
    'Diese sind nun bei uns in Bearbeitung und wir melden uns in Kürze bei Dir.',
  nowProcessed_EC: 'Wir leiten diese zur Bearbeitung weiter.',
  nowProcessed_GV: 'Diese ist nun bei uns in Bearbeitung.',
  nowProcessed_G:
    'Diese ist nun bei uns in Bearbeitung und wir melden uns in Kürze bei Ihnen. ',
  thankForUpload_LC:
    'Danke für das Hochladen Deines Dokuments!',
  thankForUpload_LC_few:
    'Danke für das Hochladen Deiner Dokumente!',
  thankForUpload_CE:
    'Danke für das Hochladen Ihres Kostenvoranschlags!',
  thankForUpload_CE_few:
    'Danke für das Hochladen Deiner Kostenvoranschläge!',
  thankForUpload_G_inv:
    'Danke für das Hochladen Ihrer Rechnung!',
  thankForUpload_G_few_inv:
    'Danke für das Hochladen Deiner Rechnungen!',
  thankForUpload_G_doc:
    'Danke für das Hochladen Deines Dokuments!',
  thankForUpload_G_few_doc:
    'Danke für das Hochladen Deiner Dokumente!',
  customerPortal: 'Kundenportal',
  thankModal_inv:
    'Vielen Dank. Wenn Du Fragen zum Bearbeitungsstand einer bereits eingereichten Rechnung hast, kannst Du diesen unter “Meine Leistungsfälle” einsehen.',
  thankModal_doc:
    'Vielen Dank. Wenn Du Fragen zum Bearbeitungsstand einer bereits eingereichten Dokument hast, kannst Du diesen unter “Meine Leistungsfälle” einsehen.',
  sureReuploadClaim_inv:
    'Bist Du sicher, dass Du die Rechnung trotzdem erneut einreichen möchtest?',
  "Implementation_date": "Durchführungsdatum",
  "The contract is terminated as of the following date": "Der Vertrag wird zum folgenden Datum gekündigt",
  sureReuploadClaim_doc:
    'Bist Du sicher, dass Du die Dokument trotzdem erneut einreichen möchtest?',
  hasDuplicate1_inv:
    'Diese Rechnung wurde bereits eingereicht und wird unter der Leistungsfallnummer ',
  hasDuplicate1_doc:
    'Diese Dokument wurde bereits eingereicht und wird unter der Leistungsfallnummer ',
  hasDuplicate2:
    ' bearbeitet. Wurden Daten – wie z.B. Diagnose oder Chipnummer ergänzt?',
  chipDoesNotMatch1_inv:
    'Die auf der Rechnung angegebene Chipnummer stimmt leider nicht mit der im Vertrag Deines Tieres hinterlegten Chipnummer überein.',
  chipDoesNotMatch1_doc:
    'Die auf der Dokument angegebene Chipnummer stimmt leider nicht mit der im Vertrag Deines Tieres hinterlegten Chipnummer überein.',
  chipDoesNotMatch2_inv:
    'Ist die auf der Rechnung angeführte Chipnummer die korrekte Chipnummer Deines Tieres?',
  chipDoesNotMatch2_doc:
    'Ist die auf der Dokument angeführte Chipnummer die korrekte Chipnummer Deines Tieres?',
  cantFindChip_inv:
    'Wir konnten leider auf Ihrer Rechnung keine Chipnummer finden, diese benötigen wir aber zur Bearbeitung. Ist die Chipnummer auf Ihrer Rechnung enthalten?',
  cantFindChip_doc:
    'Wir konnten leider auf Ihrem Dokument keine Chipnummer finden, diese benötigen wir aber zur Bearbeitung. Ist die Chipnummer auf Ihrem Dokument enthalten?',
  cantFindDiag_inv:
    'Wir konnten leider auf Ihrer Rechnung keine Diagnose finden, diese benötigen wir aber zur Bearbeitung. Ist die Diagnose auf Ihrer Rechnung enthalten?',
  cantFindDiag_doc:
    'Wir konnten leider auf Ihrem Dokument keine Diagnose finden, diese benötigen wir aber zur Bearbeitung. Ist die Diagnose auf Ihrem Dokument enthalten?',
  chipDoesNotMatch: 'Chipnummer stimmt nicht überein',
  missingDiag: 'Diagnose fehlt',
  missingChip: 'Chipnummer fehlt',
  justClick: 'Bitte klicken Sie einfach in die Felder, um Daten zu korrigieren. Klicken Sie auf „Zeile hinzufügen“, um mit dem Hinzufügen von Werten zu beginnen.',
  invoicesForVerification:
    'Diese Rechnungsposten werden zur Prüfung weitergeleitet',
  areNotRefund: 'Gibt es Rechnungsposten, die wir NICHT erstatten sollen?',
  pleaseRemove: 'Bitte klicken Sie die Posten an, die wir NICHT ERSTATTEN sollen',
  resetChanges: 'Änderungen zurücksetzen',
  correctData: 'Daten korrigieren / neue Zeile hinzufügen',
  attention:
    '*Achtung, es hat rechtliche Folgen, wenn Daten wissentlich falsch angegeben werden.',
  invoiceDetails: 'Rechnungsdetails',
  pleaseSelectClaim_G:
    'Bitte wähle den Leistungsfall aus, zu dem Du das Dokument nachreichen möchtest.',
  pleaseSelectClaim_CE:
    'Bitte wähle den Leistungsfall aus, zu dem Du die Folgerechnung nachreichen möchtest.',
  pleaseCheckData:
    'Gerne können Sie die Rechnungsdetails überprüfen und bei Bedarf anpassen. Sollten einzelne Positionen nicht korrekt übernommen sein, machen Sie sich bitte keine Sorgen – unser Team prüft alle Angaben zusätzlich manuell. Klicken Sie einfach auf „Weiter“.',
  quantity2: 'Anzahl',
  myInvoices: 'Meine Leistungsfälle',
  myProducts: 'Meine Produkte',
  whichPetContinue: 'Für welches Tier möchten Sie fortfahren?',
  submitDocument: 'Dokument einreichen',
  submitInvoice: 'Rechnung einreichen',
  uploadedDocuments: 'Hochgeladene Dokumente',
  invoiceUploadSubmitText: 'Rechnung hochladen',
  docUploadPlaceholder: 'Dokumente zum Hochladen HIER ablegen',
  keine: 'keine',
  'bei Unfall:': 'bei Unfall:',
  'bei Verkehrsunfall:': 'bei Verkehrsunfall:',
  '1 Monat': '1 Monat',
  'ab 2. Vers. Jahr:': 'ab 2. Vers. Jahr:',
  '1. Vers. Jahr': '1. Vers. Jahr',
  uploadDocument: 'Dokument hochladen',
  pleaseUpload: 'Bitte laden Sie hier ein Nachweisdokument hoch:',
  pleaseAttach:
    'Bitte laden Sie ein entsprechendes Nachweisdokument hoch (z.B. Foto des EU-Heimtierausweises).',
  pleaseAttachCustomer:
    'Bitte laden Sie ein entsprechendes Nachweisdokument hoch (z.B. Foto Ihres Personalausweises).',
  toStartPage: 'Zur Startseite',
  emailSent_main:
    'Wir haben Ihren Kündigungswunsch erhalten. Sie erhalten in Kürze eine Bestätigung per E-Mail.',
  emailSent_revoke:
    'Wir haben Ihren Widerrufswunsch erhalten. Sie erhalten in Kürze eine Bestätigung per E-Mail.',
  areYouSureToCancel_end:
    ' möchten?<br/>Sie können ihn danach nicht mehr reaktivieren.',
  areYouSureToCancel_start: 'Sind Sie sicher, dass Sie Ihren Vertrag',
  Miscellaneous: 'Sonstiges',
  'Moving abroad': 'Umzug ins Ausland',
  'Policyholder deceased': 'Versicherungsnehmer verstorben',
  AdminChangesHeader: 'Hallo, welche Änderung möchtest Du vornehmen?',
  'Animal deceased': 'Tier verstorben',
  'Animal handed over to animal welfare': 'Tier dem Tierschutz übergeben',
  'Animal sold': 'Tier verkauft',
  'Animal given away': 'Tier verschenkt',
  selectHere: 'Hier auswählen',
  afterReason3: 'Bitte geben Sie die näheren Umstände an:',
  afterReason2: 'Der Vertrag endet am XX.XX.XXXX.',
  ContractEnds1:
    'Der Vertrag endet unter Einhaltung der vertraglich geregelten Kündigungsfrist zum Vertragsende, dem ',
  hint: 'Hinweis',
  hintModal:
    'Wenn der Vertrag widerrufen/gekündigt wird, können Sie den Vertrag nicht mehr aktivieren.',
  Revocation: 'Widerruf',
  'Cancellation for other reasons': 'Kündigung aus sonstigen Gründen',
  'Ordinary cancelation': 'Ordentliche Kündigung',
  selectOption: 'Bitte wählen Sie eine Option:',
  selectOption2: 'Bitte wählen Sie eine Option',
  whicContractCancel: 'Welchen Vertrag möchtest Du kündigen?',
  whichPetCancel: 'Für welches Tier möchten Sie den Vertrag kündigen?',
  cancelContract: 'Vertrag kündigen',
  'Something going wrong...': 'Irgendetwas läuft schief...',
  'Error, reloading...': 'Fehler, neu laden...',
  claimSuccess: 'Ihr Leistungsfall wurde erfolgreich registriert.',
  noInfo: 'Keine Informationen',
  userLogin: 'Benutzer-Login',
  dateRangeError:
    'Bitte wählen Sie die korrekten Daten für den Datumsbereich aus',
  'Nicht medizinisch notwendige Kastration oder Sterilisation':
    'Nicht medizinisch notwendige Kastration oder Sterilisation',
  'Leistungen aus der Trächtigkeit (z.B. Not - kaiserschnitt)':
    'Leistungen aus der Trächtigkeit (z.B. Not - kaiserschnitt)',
  'Kieferanomalien (z.B. Persistierende Milchzähne)':
    'Kieferanomalien (z.B. Persistierende Milchzähne)',
  'Persistierende Milchzähne': 'Persistierende Milchzähne',
  'Erkrankungen, die vor Versicherungsbe - ginn oder in der Wartezeit bekannt/diagnostiziert waren':
    'Erkrankungen, die vor Versicherungsbe - ginn oder in der Wartezeit bekannt/diagnostiziert waren',
  notInsured: 'Das ist unter anderem nicht versichert',
  specialWaitingPreiod_3: 'Besondere Wartezeit von 3 Monaten',
  specialWaitingPreiod_12: 'Besondere Wartezeit von 12 Monaten',
  specialWaitingPreiod_18: 'Besondere Wartezeit von 18 Monaten',
  tariffInfo: 'Infos zu Ihrem Tarif',
  perInsYear: 'je Versicherungsjahr',
  month: 'Monat',
  pandaLoading:
    'Wir danken Ihnen! Wir sind gerade dabei, diese Informationen zu bearbeiten.',
  addDocument: 'Weiteres Dokument hinzufügen',
  dataChangesConfirmed:
    'Ihre Anfrage wurde abgeschickt. Bitte warten Sie auf unsere Antwort.',
  tooltip5: `Versicherung endet am`,
  tooltip4: 'Bitte beachte die Besonderen Wartezeiten unten in der Tabelle.',
  tooltip3_XL: 'Gesundheitspauschale in Höhe von 70€, einsetzbar für eine der folgenden Leistungen: Vorsorgeuntersuchung, Kastration/Sterilisation oder Zahnprophylaxe, Schutzimpfung, Floh- und Zeckenvorsorge, Physiotherapie und alternative Heilmethoden (z.B. Lasertherapie, Homöopathie) sowie Behandlungen auf Grund von Trächtigkeit / Entbindung.',
  tooltip3_XXL: 'Gesundheitspauschale in Höhe von 70€, einsetzbar für eine der folgenden Leistungen: Vorsorgeuntersuchung, Kastration/Sterilisation oder Zahnprophylaxe, Zahnfüllungen, Zahnersatz und Zahnkorrekturen Schutzimpfung, Floh- und Zeckenvorsorge sowie Behandlungen auf Grund von Trächtigkeit / Entbindung.',
  tooltip3_XXXL: 'Gesundheitspauschale in Höhe von 100€, einsetzbar für eine der folgenden Leistungen: Vorsorgeuntersuchung, Kastration/Sterilisation oder Zahnprophylaxe, Zahnfüllungen, Zahnersatz und Zahnkorrekturen Schutzimpfung, Floh- und Zeckenvorsorge sowie Behandlungen auf Grund von Trächtigkeit / Entbindung.',
  tooltip3: `a) Vorsorgeuntersuchungen bzw. Gesundheitschecks einschließlich Blutuntersuchungen;\nb) Zahnprophylaxe (Zahnreinigung/Zahnsteinentfernung);\nc) Wurmkuren;\nd)	Schutzimpfungen;\ne) Floh- und Zeckenvorsorge;\nf) Kastration oder Sterilisation ohne medizinische Indikation;\ng) Kürzen der Krallen;\nh) Erstellung von Gesundheitszeugnissen und Gutachten;\ni) Manuelle Analbeutelentleerung;\nj)	Tierpflegeprodukte, die über von PANDA ausgewählte Händler gekauft werden;\nk)	Behandlungen aufgrund von Trächtigkeit und Entbindung/Geburt (gilt nicht für Zuchttiere);\nl)	Krebsvorsorge und/oder Krankheits-Checkup bei Tieren aus dem Ausland.\nm) Physiotherapie und Verhaltenstherapie, sofern die jeweiligen Heilmethoden durch aner-kannte/lizensierte Physio- bzw. Verhaltenstherapeuten ausgeführt werden sowie alternative Heilmethoden (inkl. Akupunktur, Akupressur, Homöopathie, Lasertherapie, Magnetfeldtherapie, Neuraltherapie, Bioresonanztherapie, Phytotherapie, Chiropraxis und Osteopathie), sofern die Behandlungen vom Tierarzt selbst durchgeführt werden. Ausgeschlossen sind in jedem Fall Verhaltenstherapien für Katzen und alle Behandlungen durch Aderlass.

  Die Entschädigung ist auf eine der aufgeführten Leistungen bis max. 70 € je Versicherungsjahr begrenzt. Die Leistung wird auf eine bestehende Jahreshöchstleistung angerechnet.

  Wenn Sie in einem Jahr keine Erstattung für o.g. Maßnahmen erhalten haben, d.h. keine Maßnahme aus dem PANDA-Schutzbudget in Anspruch genommen haben, verdoppelt sich die Begrenzung des PANDA-Schutzbudgets im Folgejahr von 70 € auf 140 €. Im darauffolgenden Jahr gilt wieder die ursprünglich angegebene Jahreshöchstgrenze, bis die im ersten Satz genannten Voraussetzungen wieder erfüllt sind.
  `,
  tooltip2: `Du hast einen Tarif mit {{}}% Deckungssumme versichert, daher können wir nur {{}}% deiner Kosten ersetzen.`,
  'tooltip1_KR_02-2026_XXL': `Medizinisch notwendig ist eine Kastration/Sterilisation bei Vorliegen gynäkologischer oder onkologischer Erkrankungen (z. B. Entzündungen oder tumoröse Veränderungen der Geschlechtsorgane oder hormonabhängiger sonstiger Tumore).\n\nErstattung im Rahmen des PANDA Schutzbudgets bis zu 70€ möglich.`,
  'tooltip1_KR_02-2026_XXXL': `Medizinisch notwendig ist eine Kastration/Sterilisation bei Vorliegen gynäkologischer oder onkologischer Erkrankungen (z. B. Entzündungen oder tumoröse Veränderungen der Geschlechtsorgane oder hormonabhängiger sonstiger Tumore).\n\nErstattung im Rahmen des PANDA Schutzbudgets bis zu 100€ möglich.`,
  'tooltip2_02-2026': `Erstattung im Rahmen des Panda Schutzbudgets möglich.`,
  tooltip1_KR: `Medizinisch notwendig ist eine Kastration/Sterilisation bei Vorliegen gynäkologischer oder onkologischer Erkrankungen (z. B. Entzündungen oder tumoröse Veränderungen der Geschlechtsorgane oder hormonabhängiger sonstiger Tumore).\n\nErstattung im Rahmen des PANDA Schutzbudgets bis zu 70 € möglich.`,
  tooltip1_OP: `Medizinisch notwendig ist eine Kastration/Sterilisation bei Vorliegen gynäkologischer oder onkologischer Erkrankungen (z. B. Entzündungen oder tumoröse Veränderungen der Geschlechtsorgane oder hormonabhängiger sonstiger Tumore).`,
  tt_cover_70: `Sie haben einen Tarif mit 70% Deckungssumme versichert, daher können wir nur 70% Ihrer Kosten ersetzen.`,
  tt_cover_80: `Sie haben einen Tarif mit 80% Deckungssumme versichert, daher können wir nur 80% Ihrer Kosten ersetzen.`,
  tt_cover_100: `Sie haben einen Tarif mit 100% Deckungssumme versichert, daher können wir nur 100% Ihrer Kosten ersetzen.`,
  toSend: 'senden',
  supportContact: 'Support Kontakt',
  support: 'Dann kontaktiere HIER unseren SUPPORT',
  errorEmail: `ACHTUNG!<br/>Bitte gib hier die E-Mail-Adresse ein, die Du bei Abschluss der Versicherung angegeben hast.<br/><br/>Du kannst Dich nicht an Deine E-Mail Adresse erinnern?`,
  errorAdminEmail: `ACHTUNG!<br/>Bitte gib hier die E-Mail-Adresse ein, die Du bei Abschluss der Versicherung angegeben hast.<br/><br/>`,
  errorPolicyId: `ACHTUNG!<br/>Bitte geben Sie die richtige Policennummer ein.<br/><br/>`,
  codeSent:
    'Wir haben Ihnen nun an Ihre E-Mail Adresse einen Login Code gesendet. Bitte geben Sie hier den Code ein, den wir an Ihre E-Mail Adresse gesendet haben.',
  register: 'Melden Sie sich hier mit Ihrer E-Mail-Adresse an.',
  loginWelcome: 'Herzlich willkommen im PANDA Kundenportal',
  next: 'weiter',
  Amount: 'Betrag',
  empty: 'Leer',
  English: 'Englisch',
  German: 'Deutsch',
  errorMsg:
    'Ups, da ist etwas schief gelaufen. Bitte versuchen Sie es später noch einmal.',
  emailConfirmed:
    'Ihre Nachricht wurde gesendet. Bitte warten Sie auf unsere Antwort.',
  callbackConfirmed:
    'Ihre Anfrage wurde angenommen. Warten Sie auf unseren Anruf.',
  seeDetails: 'Produktdetails',
  thankMsg:
    'wir haben Deinen Anfrage erhalten.  Du wirst in Kürze eine Rückmeldung erhalten. ',
  thankMsgFooter: 'Das PANDA Team wünscht einen schönen Tag!',
  yourAttachments: 'Ihre Anhänge',
  'Vendor tax id': 'Umsatzsteuer id',
  'Vendor name': 'Name des Anbieters',
  'Vendor address recipient': 'Adresse des Lieferanten Empfänger',
  'Vendor address': 'Adresse des Anbieters',
  'Total tax': 'Steuer insgesamt',
  'Sub total': 'Zwischensumme',
  'Invoice total': 'Rechnungsbetrag',
  'Invoice id': 'Rechnung id',
  'Invoice date': 'Datum der Rechnung',
  'Customer name': 'Name des Kunden',
  'Customer id': 'Kunde id',
  'Customer address recipient': 'Kundenadresse Empfänger',
  'Customer address': 'Adresse des Kunden',
  selectDefaultValue: 'Standardwert auswählen',
  'to review': 'zur Überprüfung',
  'Policy is not terminated': 'Die politik wird nicht gekündigt',
  'to reject': 'abzulehnen',
  'to be paid': 'zu entrichten',
  Prevention: 'Prävention',
  Accident: 'Unfall',
  values: 'Werte',
  'Default value': 'Standardwert',
  'Existing claim': 'Weitere Fragen',
  'Additional questions': 'Weitere Fragen',
  'Date range': 'Datumsbereich',
  'Invoice Table': 'Tabelle der Rechnungen',
  Date: 'Datum',
  Upload: 'Hochladen',
  'Multiple Choice Question': 'Multiple Choice Frage',
  'End flow': 'Fluss beenden',
  Type: 'Typ',
  'New claim': 'Neues Dokument',
  'New Document': 'Neues Dokument',
  'Open question': 'Offene Frage',
  fullWidth: 'Volle Breite',
  halfWidth: 'Halbe Breite',
  disabled: 'Behinderte',
  enterEmail: 'Geben Sie hier Ihre neue E-Mail-Adresse ein:',
  enterBD: 'Geben Sie hier Ihr Geburtsdatum ein:',
  changeElse: 'Etwas anderes ändern',
  "YY": "JJ",
  "DD": "TT",
  "MM": "MM",
  changeBD: 'Geburtsdatum ändern',
  changeEmail: 'E-Mail Adresse ändern',
  whatChange: 'Was möchten Sie ändern?',
  selectDate: 'Deinen Wunschtermin auswählen',
  yourPhone: 'Deine Telefonnummer',
  sendChoose: `Bitte hinterlasse uns einfach Deine <span>Telefonnummer</span> und wähle Deinen <span>Wunschtermin</span> aus.`,
  willDiscuss:
    'Wir rufen Dich an und besprechen gerne mit Dir alle Deine Fragen!',
  arrangeCall: 'Anruftermin vereinbaren',
  message: 'Nachricht',
  yourName: 'Dein Name',
  replyAsap: 'Wir antworten umgehend!',
  sendUsEmail: 'Senden Sie uns eine E-Mail an',
  uploadPhoto: 'Bild hochladen',
  billDir: 'Direktverrechnung mit Tierarzt/Tierklinik',
  costCalc: 'Kostenvoranschlag',
  resendDocs: 'Dokument nachreichen',
  sendBill: 'neue Rechnung einreichen',
  claim: 'Leistungsfall',
  claimNo: 'Leistungsfall-Nr.',
  cdSecond: 'ändern',
  cdFirst: 'Daten',
  callBack: 'Rückruf anfordern',
  sendEmail: 'E-Mail senden',
  variants: 'Varianten',
  notInvoice: 'Keine Rechnung',
  noCategory: 'Keine Kategorie',
  noTrigger: 'Kein Auslöser',
  preventionStatus: 'Status der Prävention',
  secondTrigger: 'Zweiter Auslöser',
  firstTrigger: 'Erster Auslöser',
  noStatus: 'Kein Status',
  typeSelect: 'Bitte wählen Sie die Art der Leistungsfall',
  prevention: 'Prävention',
  accident: 'Unfall',
  treatment: 'Behandlung',
  preventionTreatment: 'Prävention & Behandlung',
  PreventionTreatment: 'Prävention & Behandlung',
  submitEmail: 'E-Mail abschicken',
  submitPolicy: 'ID-Politik einreichen',
  confirmEmail: 'Bestätigen Sie Ihre neue E-Mail',
  confirmCode: 'Bestätigungscode',
  submitCode: 'Code einreichen',
  getConfirmCode: 'Bestätigungscode erhalten',
  whatToDo: 'Was möchten Sie tun?',
  changeContract: 'Vertrag ändern',
  pandaBudget: 'PANDA Schutzbudget',
  waitingStart: 'Wartezeit ab Versicherungsbeginn',
  annMaxTreat: 'Jahreshöchstleistung Behandlungen',
  annMaxOPs: 'Jahreshöchstleistung OPs',
  compensations: 'Kostenersatz',
  whatCovered: `Was ist in Ihrem <span>Tarif</span> gedeckt?`,
  changePayment: 'Zahlungsweise ändern',
  paymentMethod: 'Zahlungsmethode',
  insPremium: 'Versicherungsprämie',
  krankenExklusiv: 'Krankenschutz Exklusiv',
  changeData: `Datenänderungswunsch`,
  changePetData: 'Daten des Tieres ändern',
  Selection: 'Auswahl',
  backTo: 'zurück zur ',
  firstSight: 'auf einen Blick',
  petProduct: 's Produkte',
  uploadFoto: 'Lade hier ein Bild Deines Vierbeiners hoch.',
  allAnimals: 'Alle Tiere',
  whichPet: 'Welches Tier möchten Sie auswählen?',
  userMode: 'Benutzermodus',
  vet: 'Tierarzt',
  noDiag: 'Keine Diagnose',
  add: 'Hinzufügen',
  allDatesSame: 'Alle Daten als erste einstellen',
  askForEdit: 'Andere Änderungen beantragen',
  diagnosisTrigger: 'Diagnose Auslöser',
  mixedBill: 'Gemischte Rechnung',
  prevTrue: 'Prävention wahr',
  prevFalse: 'Prävention falsch',
  prevMixedBill: 'Prävention gemischte Rechnung',
  prevNotSure: 'Prävention nicht sicher',
  recTriggers: 'Erkannte Auslöser',
  width: 'Breite',
  notSure: 'Nicht sicher',
  done: 'Erledigt',
  question: 'Frage',
  vendorName: 'Name des Anbieters',
  payment: 'Zahlung',
  Invoice: 'Rechnung',
  invoice: 'Rechnung',
  editDamage: 'Leistungsfall bearbeiten',
  Cancel: 'Abbrechen',
  itMight:
    'Dies könnte das Antragsverfahren wieder in Gang setzen und somit die Entscheidung verzögern.',
  areYouSure: 'Sind Sie sicher?',
  ShowUnread: 'zeige ungelesene Nachrichten an',
  save: 'Speichern Sie',
  vendorAddress: 'Adresse des Anbieters',
  vendorTaxId: 'Steuer-ID des Verkäufers',
  TreatmentDate: 'Behandlungsdatum',
  TreatmentType: 'Art der Behandlung',
  SecondaryColor: 'Sekundäre Farbe',
  PrimaryColor: 'Primäre Farbe',
  Settings: 'Einstellungen',
  Font: 'Schriftart',
  Logout: 'Abmeldung',
  createDropdown: 'Dropdown erstellen',
  editDropdown: 'Dropdown bearbeiten',
  BackToFlow: 'Zurück zum Fluss',
  Options: 'Optionen',
  actions: 'Aktionen',
  Trigger: 'Auslöser',
  Category: 'Kategorie',
  preventionEmpty: 'Keine weiteren Gegenstände.',
  itemInfo: 'Aufgeschlüsselte Informationen',
  totalInfo: 'Gesamt info',
  update: 'Aktualisierung',
  ocrLoaded: 'OCR geladen.',
  confirmed: 'Bestätigt!',
  duplTrue: 'Duplizieren wahr',
  duplFalse: 'Duplizieren falsch',
  seeLineItems: 'Siehe Einzelposten',
  seeInitDoc: 'Siehe Ausgangsdokument',
  damageLocation: 'Ort der Beschädigung',
  damage: 'Leistungsfall',
  breed: 'Rasse',
  firstBreed: 'Erste Rasse',
  secondBreed: 'Zweite Rasse',
  gender: 'Anrede',
  incidentDate: 'Datum des Vorfalls',
  decisionDate: 'Entscheidungsdatum',
  AdminChanges: 'Admin Änderungen',
  petNameTrigger: 'Kosename Auslösewort',
  chipNumberTrigger: 'Chip-Triggerwort',
  petInfo: 'Haustier-Infos',
  invoiceInfo: 'Informationen auf der Rechnung',
  confirm: 'Bestätigen Sie',
  search: 'Suche',
  allDamages: 'Alle Schäden',
  auditClaims: 'Audit-Leistungsfälle',
  auditDuplicated: 'Audit Dupliziert',
  auditPrevention: 'Audit Prävention',
  auditOCR: 'Audit OCR',
  rate: 'Erfolgsquote',
  auditClaimsBack: 'Zurück zur Audit-Seite',
  yes: 'Ja',
  no: 'Nein',
  allCompared: 'Alle Artikel im Vergleich.',
  isOfPending: 'Leistungsfälle anhängig ist aus',
  comment: 'Kommentar',
  petTriggerTooltip:
    'Bitte schreiben Sie das Wort, das Ihnen geholfen hat, das Haustier zu identifizieren',
  chipTriggerTooltip:
    'Bitte schreiben Sie das Wort, das Ihnen geholfen hat, die Chipnummer zu identifizieren',
  identifiedWrong: 'Falsch identifiziert',
  identifiedSuccess: 'Korrekt identifiziert',
  checked: 'Geprüft',
  claimsReviewed: 'Überprüfte Leistungsfälle',
  claimsPendingReview: 'Zu prüfende Leistungsfälle',
  totalTax: 'Steuer',
  match: 'Passen',
  veterinarian: 'Name des Tierarztes',
  petName: 'Name des Haustiers',
  policyID: 'ID-Politik',
  policyNo: 'Vertragsnummer',
  typeToSearch: 'Zum Suchen von Richtlinien eingeben',
  updateLogo: 'Logo aktualisieren',
  about: 'Um',
  Finish: 'Beenden',
  lineItem_one: 'Einzelposten',
  lineItem_other: 'Einzelposten',
  myTransactions: 'Meine Transaktionen',
  'complete the flow': 'runden den Ablauf ab',
  fillInfo: 'Füllen Sie die Informationen aus',
  inProgress: 'im Gange',
  invoiceTotalCheckPassed: 'Rechnungssummenprüfung bestanden.',
  invoiceTotalCheckFailed: 'Rechnungssummenprüfung fehlgeschlagen.',
  totalNet: 'Total netto',
  totalGross: 'Gesamtbrutto',
  VatCheckPassed: 'Umsatzsteuerprüfung bestanden.',
  VatCheckFailed: 'Mehrwertsteuerprüfung fehlgeschlagen.',
  tax: 'Steuer',
  taxId: 'Steuer ID',
  yourVendorInfo: 'Die Informationen Ihres Anbieters',
  editVendorInfo: 'Bearbeiten Sie die Informationen Ihres Anbieters',
  yourInfoNotUpDate: 'Ihre Daten sind nicht aktuell?',
  customerNumber: 'Kundennummer',
  myPets: 'Meine Haustiere',
  yourInfo: 'Ihre Informationen',
  zoomView: 'Zoom-Ansicht',
  zoom: 'Zoomen',
  goBack: 'Geh zurück',
  editView: 'Ansicht bearbeiten',
  updateFlow: 'Fluss aktualisieren',
  status: 'Status',
  action: 'Aktion',
  policyNumber: 'Policennummer',
  customerName: 'Kundenname',
  noClaims: 'Keine Leistungsfälle vorhanden',
  quantity: 'Quantität',
  amount: 'Rechnungsbetrag',
  amount2: 'Netz',
  netto: 'Netto',
  id: 'id',
  moreDetails: 'mehr Details',
  taxAndName: 'Steuernummer und Name',
  answersCompleted: 'Alle Antworten in diesem Flow wurden abgeschlossen!',
  fillMissingInfo: 'Alle Antworten in diesem Flow wurden abgeschlossen!',
  from: 'Aus',
  to: 'Zu',
  answer: 'Antworten',
  customerNum: 'Kunden-Nr.',
  email: 'E-Mail Addresse',
  weAreAnalyzing: 'Wir analysieren Ihre Informationen',
  saveChanges: 'Änderungen speichern',
  phone: 'Telefonnummer',
  element: 'ELEMENT',
  address: 'Anschrift',
  street: 'Straße',
  houseNumber: 'Hausnummer',
  contactDetails: 'Kontaktdaten',
  city: 'Stadt',
  birthDate: 'Geburtsdatum',
  postcode: 'PLZ',
  noTransactions: 'Es gibt keine Transaktionen',
  insurances: 'Versicherungen',
  reportDamage: 'Rechnung einreichen',
  tryAsClient: 'Versuchen Sie es als Kunde',
  adminMode: 'Admin-Modus',
  personalData: 'Persönliche Daten',
  flowManagement: 'Flowmanagement',
  myDamages: 'Meine Leistungsfälle',
  protectedInsuranceArea: 'Geschützter Versicherungsbereich',
  loginInfo: `Für die Einsicht Ihrer Versicherungsunterlagen melden Sie
                      sich bitte in unserem geschützten Bereich an. Hier finden
                      Sie unter anderem Informationen zum Thema Schadenmeldung.
                      Nach Angabe Ihrer E-Mail-Adresse erhalten Sie einen
                      Zugangslink. Sie können auch Ihre Policen-ID senden und
                      einen Bestätigungscode an Ihre E-Mail-Adresse senden.`,
  yourNewEmail: 'Ihre neue E-Mail Adresse',
  yourPassword: 'Ihr Passwort',
  requestLoginLink: 'Login Link anfordern',
  pandaPetIns: 'Panda Tierversicherungen',
  pandaInsurTech: 'Panda InsurTech GmbH',
  riskTaker: 'Risikoträger',
  riskTakerAddress: `InterRisk Versicherungs-AG
  <br />
  Vienna Insurance Group
  <br />
  Carl-Bosch-Str. 5
  <br />
  65203 Wiesbaden
  <br />
  Deutschland`,
  commercial: 'Handelsregister:',
  commercialRegister: `<span>HRB 8043</span>
  <br />
  Registergericht Wiesbaden
  <br />
  VersSt-Nr.: 807/V90807012122`,
  member: 'Mitglieder des Vorstandes:',
  memberBoard: `<span>
              Dr. Florian Sallmann (Vorsitzender),
              <br />
              Beate Krost,
              <br />
              Christoph Wolf
            </span>
            <br />
            <strong>
            Vorsitzender des Aufsichtsrates:
            </strong>
            <br />
            Mag. Liane Hirner (Vorsitzende)`,
  imprint: 'Impressum',
  dataProtection: 'Datenschutz',
  contact: 'Kontakt',
  faq: 'FAQ',
  createFlow: 'Fluss erzeugen',
  flows: 'Fließt',
  noFlowsCreateNew: 'Keine Strömungen. Erstellen Sie eine neue!',
  diagnosis: 'Diagnose',
  got: 'GOT',
  edit: 'bearbeiten',
  delete: 'löschen',
  weWorkingClaims: 'Wir arbeiten an Ihrem Leistungsfall.',
  goBackSeeHistory: `Sie können zum Verlauf der Leistungsfälle zurückkehren, um den Status Ihrer Leistungsfälle anzuzeigen Leistungsfälle und füllen Sie alle fehlenden Informationen aus.`,
  close: 'Schließen',
  hallo: 'Hallo',
  fifiChipMissing: 'Die Chipnummer von Kelly fehlt noch.',
  addDetails: 'Details ergänzen',
  pandaPetHealth: 'Panda Tierkrankenversicherung',
  productVariant: 'Produktvariante: Panda Vollkrankenschutz Exklusiv',
  active: 'aktiv',
  commOfIns: 'Versicherungsbeginn',
  renewsOn: 'Die Versicherung wird automatisch verlängert am',
  cancelledOn: 'Produkt storniert per',
  insNumber: 'Versicherungsnummer',
  petHealthDesc: `Ihre Tierkrankenversicherung schützt Sie vor den
                          Kosten im Falle einer notwendigen Operation oder
                          Heilbehandlung (sofern vereinbart) wegen Krankheit
                          oder Unfall Ihres Tieres.`,
  details: 'Einzelheiten',
  monthly: 'monatlich',
  paymentInfo: 'Zahlungsinformation',
  transactionHis: 'Transaktionsverlauf',
  reimCost: 'Kostenerstattung im Leistungsfall',
  insDog: 'Versicherter Hund',
  chipNumber: 'Chipnummer',
  downloadDoc: 'Dokumente herunterladen',
  downloadDoc2: 'Dokumente erhalten',
  showLess: 'Weniger anzeigen',
  moreInfoDoc: 'Weitere Informationen & Dokumente',
  faqLong: 'Häufige gestellte Fragen',
  selectInvoice: 'Wählen Sie das Dokument',
  name: 'Name',
  type: 'Typ',
  size: 'Größe',
  group: 'Gruppe',
  item_one: 'Artikel',
  item_other: 'Artikel',
  groupIntoOne: 'In einem Anspruch gruppieren',
  analyzeNow: 'Jetzt analysieren!',
  preview: 'Vorschau',
  back: 'zurück',
  Back: 'Zurück',
  Next: 'Weiter',
  infoAboutDamage: 'Angaben zum schadenfall',
  date: 'Datum',
  time: 'Uhrzeit',
  invoiceNumber: 'Rechnungsnummer',
  describeWhatHappen:
    'Bitte beschreiben Sie so genau wie möglich, was passiert ist',
  specificInfo: '1. Spezifische Angaben zum Erstattungsantrag',
  pet: 'Haustier',
  yourDogChip: 'Die Mikrochipnummer Ihres Hundes',
  whatTreatmentType: 'Welche Art von Behandlung hat Ihr Hund erhalten?',
  whatTreatmentTakePlace: 'Wann fand die Behandlung statt?',
  preIdentifyDiag: 'Voridentifizierte Diagnose (eine auswählen)',
  noneAbove: 'Nichts des oben Genannten',
  info: 'Information',
  symptoms: 'Symptome',
  cause: 'Ursache(n)',
  confirmSelection: 'Auswahl bestätigen',
  otherDiag: 'Andere Diagnose (eine auswählen)',
  diag: 'Diagnose',
  invoiceDate: 'Rechnungsdatum',
  desc: 'Beschreibung',
  count: 'Zählen',
  unitPrice: 'Einzelpreis',
  total: 'Gesamt',
  totalAmount: 'Gesamtbetrag',
  totalAmount2: 'Brutto',
  addGot: 'GOT hinzufügen',
  gotCheckPass: 'GOT-Check bestanden',
  gotCheckFailed: 'GOT-Prüfung fehlgeschlagen.',
  gotSelection: 'GOT-Auswahl',
  noGotSelection: 'Kein GOT ausgewählt',
  updateGot: 'GOT aktualisieren',
  updateInfo: `Wenn Sie Ihre Informationen aktualisieren, wird der Fortschritt nicht gespeichert und
             Sie müssen diese Rechnung hochladen. Sie können diesen Schritt auch beenden
             und aktualisieren Sie Ihre Informationen später.`,
  profilePage: 'Profilseite',
  updateVendorInfo: 'Lieferanteninformationen aktualisieren',
  updateInformation: 'Informationen aktualisieren',
  paymentInformation: `Im Falle einer Rückerstattung sollte die Zahlung wie folgt erfolgen
         Konto:`,
  cardNumber: 'IBAN',
  accountOwner: 'Kontoinhaber',
  questionOrSuggestion: 'Sie haben eine Frage oder Anregung?',
  send: 'Abschicken',
  title: 'Titel',
  firstName: 'Vorname',
  lastName: 'Nachname',
  attach: 'Dokument hinzufügen',
  rechnungen: 'Leistungsfälle',
  Rechnungen: 'Leistungsfälle',
  AdditionalProperties: 'Zusatzinformationen zum Leistungsfall',
  dateRangePlaceHolder: 'Anfang - Ende',
  enter: 'Gebe HIER Deine Anfrage ein.',
  createNewApproach: 'Neuen Anahng erstellen',
  sendRequest: 'Anfrage senden',
  sendChange: 'Änderungswunsch senden',
  otherRequest: 'Andere Anfrage',
  enterDate: 'Datum eingeben',
  retriever: 'Nova Scotia Duck Tolling Retriever',
  changeBirthOrAdress: 'Kundengeburtstag/E-Mail-Adresse',
  changeAdminContract: 'Änderung am Vertrag',
  CancellationOrRevocation: 'Kündigung/Widerruf',
  What_would_you_like_to_do: 'Was möchten Sie tun?',
  enterMtaDate: 'Bitte MTA-Datum eingeben',
  enterCustomerComment: 'Warum waren Sie beim Tierarzt?',
  upload: 'Hier kannst Du Deine Rechnungen hochladen',
  customerComment: 'Bitte schildern Sie den Grund für Ihren Tierarztbesuch:',
  contractRevoked: 'Vertag widerrufen',
  cannotUploadNewClaims: 'Leider können Sie zu diesem Vertrag keine Rechnung hochladen, da der Vertrag bereits widerrufen wurde.',
  
  // Status mappings: key is Insly status, value is { display: 'Display Name', tooltip: 'Tooltip message' }
  claimStatusMap: {
    'open - ready for automation': { display: 'Offen', tooltip: 'Ihr Leistungsfall ist erfolgreich bei uns eingegangen.' },
    'open - ready for review': { display: 'In Bearbeitung', tooltip: 'Ihr Leistungsfall befindet sich in bearbeitung.' },
    'open': { display: 'Offen', tooltip: 'Ihr Leistungsfall ist erfolgreich bei uns eingegangen.' },
    'on hold - reply outstanding': { display: 'Antwort austehend', tooltip: 'Wir haben eine Rückfrage an Sie gestellt und warten auf Ihre Antwort.' },
    'on hold - premium not paid': { display: 'Prämie nicht bezahlt', tooltip: 'Ihre Prämie war zum Zeitpunkt der Behandlung nicht gedeckt.' },
    'in progress': { display: 'In Bearbeitung', tooltip: 'Ihr Leistungsfall befindet sich in bearbeitung.' },
    'closed - payment released': { display: 'Zahlung freigegeben', tooltip: 'Ihr Leistungsfall ist zur Zahlung freigegeben.' },
    'closed - rejection': { display: 'Abgelehnt', tooltip: 'Ihr Leistungsfall wurde abgelehnt. Weiter Informationen können der E-Mail entnommen werden.' },
    'closed - no customer respond': { display: 'Keine Rückmeldung', tooltip: 'Ihr Leistungsfall wurde geschlossen, da wir keine Rückmeldung auf unsere Anfrage erhalten haben.' },
    'in Revision': { display: 'In Revision', tooltip: 'Ihr Leistungsfall befindet sich in Revision.' },
    'reopened': { display: 'Wiedereröffnet', tooltip: 'Ihre nachgereichten Unterlagen wurden erfolgreich zum Leistungsfall hinzugefügt und sind zur Bearbeitung bereit.' },
    'Recovery created': { display: 'Regress gestartet', tooltip: 'Der Regress wurde angefordert.' },
    'Recovery settled': { display: 'Regress abgeschlossen', tooltip: 'Der Regress wurde abgeschlossen.' },
    'canceled': { display: 'Abgelehnt', tooltip: 'Ihr Leistungsfall wurde abgelehnt. Weiter Informationen können der E-Mail entnommen werden.' },
    'closed - payment issued': { display: 'Zahlung erfolgt', tooltip: 'Die Zahlung Ihres Leistungsfalles ist abgeschlossen.' },
    'closed - incorrectly created': { display: 'Falschanlage', tooltip: 'Die eingereiten Rechnungen wurden einem bereits bestehenden Leistungsfall zugeordnet.' },
    'closed - double submission': { display: 'Doppeleinreichung', tooltip: 'Die Rechnung wurde bereits in einem bestehenden Leistungsfall bearbeitet.' },
    'closed - reply outstanding': { display: 'Antwort austehend', tooltip: 'Wir haben eine Rückfrage an Sie gestellt und warten auf Ihre Antwort.' },
  },
};
